/*

& The redux store: the global slice (every reducer), the store wrapper and the thunk exports.

  10 Oct 2026: the delete_account slice (the old delete-link token) and the thunks and
  reducers that served the old delete flows (deleteBusinessProfile, sendDeleteBPLink) were
  removed; deletion now uses a server-sent code (lib/teams/deleteFlowsClient).

*/

/*

? Let's import the necessary redux components

*/

import { ThunkAction, configureStore, createSlice } from "@reduxjs/toolkit";
import { HYDRATE, createWrapper } from "next-redux-wrapper";
import { Action } from "redux";

/*

? And then, we'll import the default global state data and it's corresponding interface

*/

/*

/*

? Now we'll import all the reducers we're going to use in this app

*/

import { generateInitialSearchFiltersReduxState } from "../lib/data/search-filters/helpers";
import {
	AddHonorsAndAwardsDetailsForUser,
	AddLicenseAndCertificationDetailsForUser,
	AddSaveEntityBusinessProfile,
	AddSaveEntityUserProfile,
	AddSepcialOfferDetailsForBusinessProfile,
	AddUserCourses,
	AddUserLanguage,
	AddingBeegruPointsForShareService,
	AllowcopyProperty,
	BusinessDashboardCancelSubscription,
	BusinessDashboardCreateNewSubscription,
	BusinessDashboardRenewSubscription,
	CancelPropertyBoostState,
	CancelSubscription,
	CreateCrmIntegrationWebhook,
	CreateNewBugReport,
	CreateNewComments,
	CreateNewCommentsUserPost,
	CreateNewPost,
	CreateNewPostUser,
	CreateNewReport,
	CreateNewReview,
	CreateNewService,
	CreateNewShares,
	CreateNewSubscription,
	CreateNewView,
	CreatePropertyBoostState,
	EmployeeRequest,
	FaqAddDownvote,
	FaqAddUpvote,
	FaqRemoveDownvote,
	FaqRemoveUpvote,
	FetchBusinessDashboardAnalyticsGraph,
	FetchBusinessDashboardAnalyticsGraphCustomDates,
	FetchBusinessDashboardAnalyticsLeadsThisWeek,
	FetchBusinessDashboardAnalyticsListingViewsThisWeek,
	FetchBusinessDashboardAnalyticsMostLeadsGeneratingListing,
	FetchBusinessDashboardAnalyticsMostSavedListing,
	FetchBusinessDashboardAnalyticsMostViewedListing,
	FetchBusinessDashboardAnalyticsProfileViews,
	FetchMoreBusinessProfiles,
	KycProfileTypes,
	LoadingMoreBusinessProfileGivenReviews,
	LoadingMoreBusinessProfilePosts,
	LoadingMoreBusinessProfileReviews,
	LoadingMoreUserGivenReviews,
	LoadingMoreUserProfilePosts,
	LoadingMoreUserReviews,
	NewEmployeeRquestOnBoarding,
	OnBoarding,
	ProfileToUpgrade,
	ProfileToUpgradeId,
	ProfileToUpgradeType,
	RemoveBooms,
	RenewSubscription,
	ReplyToComment,
	SetDefaultLocation,
	SetDefaultLocationBoost,
	SetDefaultLookingFor,
	SetPlatformAccessLevel,
	SetPropertyBoostDataState,
	SetPropertyBoostDetailState,
	SetPropertyBoostLocationState,
	// PropertyBoost
	SetPropertyBoostMobileStepState,
	SetPropertyBoostModalState,
	SetPropertyBoostPointsState,
	SetPropertyBoostSnackState,
	SetPropertyBoostedByState,
	SetPropertyLoadingState,
	SetTeamInvite,
	Setintro,
	ShowContactDetailsProperty,
	ShowContactDetailsService,
	TestCrmIntegrationWebhook,
	UpdateAboutDeveloperProperty,
	UpdateAboutLocationProperty,
	UpdateAboutProperty,
	UpdateAiOverView,
	UpdateAmenities,
	UpdateBusinessAbout,
	UpdateBusinessBrokerage,
	UpdateBusinessExpertise,
	UpdateBusinessFAQs,
	UpdateBusinessLanguages,
	UpdateBusinessLicences,
	UpdateBusinessProfileAboutDetails,
	UpdateBusinessProfileAreasOfOperation,
	UpdateBusinessProfileEmail,
	UpdateBusinessProfileEstDate,
	UpdateBusinessProfileLanguages,
	UpdateBusinessProfileLeadsNotes,
	UpdateBusinessProfileLeadsStatus,
	UpdateBusinessProfileListingsCount,
	UpdateBusinessProfileOfficeAddresses,
	UpdateBusinessProfilePhone,
	UpdateBusinessProfilePicture,
	UpdateBusinessProfileShortDescription,
	UpdateBusinessProfileSpecialization,
	UpdateBusinessProfileTitle,
	UpdateBusinessProfileWebsite,
	UpdateBusinessProfilecountry_code,
	UpdateBusinessServices,
	UpdateConfigAndArea,
	UpdateCrmIntegrationWebhook,
	UpdateOverView,
	UpdatePropertyDetails,
	UpdatePropertyRegulatoryInfo,
	UpdatePropertyTitle,
	UpdateReduxSessionUserFields,
	UpdateServiceAreasOfOperation,
	UpdateServiceDetails,
	UpdateServiceOverView,
	UpdateServiceProvider,
	UpdateServiceSpecification,
	UpdateServiceTitle,
	UpdateUserAboutDetails,
	UpdateUserDetail,
	UpdateUserProfileLeadsNotes,
	UpdateUserProfileLeadsStatus,
	UpdateUserSkills,
	UpdateVicinity,
	acceptEmployeeRequest,
	acceptedBroadcast,
	addAdminUserDetails,
	addBusinessProfilePicture,
	addCoverImage,
	addExperienceForUser,
	addNewBusinessProfileAdmin,
	addNewNoteToLeadActivityLogs,
	addProfilePicture,
	addPropertyImages,
	addServiceImages,
	addingbeegrupointsshareproperty,
	bookmark,
	businessDashboardAddAdminUserDetails,
	businessDashboardDeleteAdminUserDetails,
	businessProfileListTabView,
	cancelBoost,
	changeAutoplayVideos,
	changeDataTuning,
	changeDefaultVideoQuality,
	changeMe,
	changeRecievePromotionalEmails,
	closeRequirement,
	commentSwr,
	createNewBroadcast,
	createNewBusinessProfile,
	createNewOFBProperty,
	createNewOFBPropertyUser,
	createNewProperty,
	createNewPropertyWithUploadTool,
	createNewServiceWithUploadTool,
	createRequirement,
	cropPropertyImage,
	cropServiceImage,
	deleteAdminUserDetails,
	deleteBusinessProfilePicture,
	deleteChat,
	deleteChatMessage,
	deleteDesktopLeads,
	deleteEmployeeRequest,
	deleteMobileLeads,
	deletePostUser,
	deletePropertyDetails,
	deletePropertyImage,
	deletePropertyOFBDetails,
	deletePropertyOFBUsers,
	deleteReview,
	deleteServiceDetails,
	deleteServiceImage,
	deleteUserCoverImage,
	deleteUserProfilePicture,
	fetchAboutSingleProperty,
	fetchAccountSettingsFilesCount,
	fetchAccountSettingsPageData,
	fetchAccountSettingsProfileKycInfo,
	fetchAccountSettingsRewardtransactions,
	fetchAccountSettingsSubscriptions,
	fetchAccountSettingsSubscriptionsPlans,
	fetchAccountSettingsUserBeegruPointstransactions,
	fetchAccountSettingsUserCashtransactions,
	fetchAccountSettingsUserData,
	fetchAiBoostAllBoostLists,
	fetchAiBoostAllBoostListsLoading,
	fetchAiBoostBannerCardDetails,
	fetchAiBoostBannerCardDetailsLoading,
	fetchAiMetaActiveCampaigns,
	fetchAiMetaBoostedListings,
	fetchAllCampaignMetrics,
	fetchBoostBusinessProfilePageData,
	fetchBoostPostPageData,
	fetchBoostPropertyPageData,
	fetchBoostServicePageData,
	fetchBoostUserProfilePageData,
	fetchBusinessDashboarMembersAndAdminsData,
	fetchBusinessDashboardActivityLogsData,
	fetchBusinessDashboardAdmins,
	fetchBusinessDashboardBeegruPointTransactions,
	fetchBusinessDashboardBoostsMobile,
	fetchBusinessDashboardCashTransactions,
	fetchBusinessDashboardKycInfo,
	fetchBusinessDashboardLeadsDesktop,
	fetchBusinessDashboardLeadsMobile,
	fetchBusinessDashboardLeadsOverview,
	fetchBusinessDashboardListings,
	fetchBusinessDashboardListingsCount,
	fetchBusinessDashboardOFBsOverview,
	fetchBusinessDashboardPaymentTransactions,
	fetchBusinessDashboardProfileData,
	fetchBusinessDashboardPropertiesOverview,
	fetchBusinessDashboardReferrals,
	fetchBusinessDashboardReviewsMobile,
	fetchBusinessDashboardRewards,
	fetchBusinessDashboardRewardsHistory,
	fetchBusinessDashboardSavedItems,
	fetchBusinessDashboardServicesOverview,
	fetchBusinessDashboardTeamMembers,
	fetchBusinessProfileAboutDetails,
	fetchBusinessProfileAdmins,
	fetchBusinessProfileAdminsDetailsAndEmployeeRequest,
	fetchBusinessProfileAnalyticsOFBs,
	fetchBusinessProfileAnalyticsPost,
	fetchBusinessProfileAnalyticsProperty,
	fetchBusinessProfileAnalyticsService,
	fetchBusinessProfileBrokerage,
	fetchBusinessProfileExpertise,
	fetchBusinessProfileFaqs,
	fetchBusinessProfileFollowerAndFollowing,
	fetchBusinessProfileGivenReviews,
	// fetchHomePageTrendingBusinessProfilesData,
	fetchBusinessProfileImages,
	fetchBusinessProfileLanguages,
	fetchBusinessProfileLeads,
	fetchBusinessProfileLicencesAndCertificates,
	fetchBusinessProfileListingOFB,
	fetchBusinessProfileListingProperty,
	fetchBusinessProfileListingService,
	fetchBusinessProfileNoOfEmployees,
	fetchBusinessProfilePosts,
	fetchBusinessProfilePublishedProperties,
	fetchBusinessProfilePublishedServices,
	fetchBusinessProfileReviews,
	fetchBusinessProfileSavedOFB,
	fetchBusinessProfileSavedPost,
	fetchBusinessProfileSavedProperty,
	fetchBusinessProfileSavedService,
	fetchBusinessProfileServiceOffered,
	fetchBusinessProfileSubscription,
	fetchBusinessProfileUserViewListings,
	fetchChatMessages,
	fetchClientCrmIntegrationWebhook,
	fetchCoreDetailsAndImages,
	fetchCuratedPropertyIds,
	fetchDevelopers,
	fetchFaqs,
	fetchFeatureDiscoveryTracker,
	fetchGlobalSearchResults,
	fetchGoogleAIBoostCampaignMetrics,
	fetchGoogleAIBoostsQualifiedLeads,
	fetchGoogleCampaignsLists,
	fetchHomePageBeegruTopPicksData,
	fetchHomePageData,
	fetchHomePageFeaturedPlotsData,
	fetchHomePageFeaturedPropertiesData,
	fetchHomePageHotPropertiesBuyLocalStorageData,
	fetchHomePageHotPropertiesData,
	fetchHomePageHotPropertiesOfbLocalStorageData,
	fetchHomePageHotPropertiesRentLocalStorageData,
	fetchHomePageStats,
	// fetchHomePageTrendingUsersData,
	fetchHomePageTopBusinessProfilesData,
	fetchHomePageTopDevelopersData,
	fetchHomePageTopServicesData,
	// fetchHomePageTrendingServicesData,
	fetchHomePageTopUsersData,
	fetchHomePageTopVillasData,
	fetchHomeScreenBroadcastWidget,
	fetchHomepageDashboardStats,
	fetchKeyHighlights,
	fetchLeadsById,
	fetchLocalitiesFaq,
	fetchMapDetailsAndVicinity,
	fetchMetaAiBoostActivityLogdData,
	fetchMetaAiBoostAllAdIds,
	fetchMetaAiBoostsAdCreatives,
	fetchMetaAiBoostsBudgetDetails,
	fetchMetaAiBoostsCampaignStats,
	fetchMetaAiBoostsQualifiedLeads,
	fetchMyRequirements,
	fetchNearbyProperties,
	fetchNeighbourhoodReviewsPageData,
	fetchNotificationPage,
	fetchOnBoardingBusinessTitle,
	fetchOneTimeRewards,
	fetchPerformanceAnalyticsBusinessDashboardHomeWidget,
	fetchPriceTrends,
	fetchPropertyCardData,
	fetchPropertyDataReviewsPageData,
	fetchPropertyReviewsPageData,
	fetchPropertyUserDataReviewsPageData,
	fetchRealtimeNewChatMessage,
	fetchRealtimeNotification,
	fetchReceiptPageData,
	fetchReceivedBroadcasts,
	fetchRecomendedPropertiesToBoost,
	fetchRecurringRewards,
	fetchRequirementsFeed,
	fetchRequirementsFeedCounts,
	fetchSearchData,
	fetchSentBroadcasts,
	fetchServiceDataReviewsPageData,
	fetchServiceReviewsPageData,
	fetchServiceUserDataReviewsPageData,
	fetchSingleBusinessProfile,
	fetchSingleFaq,
	fetchSinglePost,
	fetchSingleProperty,
	fetchSinglePropertyAboutLocation,
	fetchSinglePropertyAmenities,
	fetchSinglePropertyConfigAndArea,
	fetchSinglePropertyCreator,
	fetchSinglePropertyDetails,
	fetchSinglePropertyDeveloper,
	fetchSinglePropertyHotProperties,
	fetchSinglePropertyImages,
	fetchSinglePropertyLocationCoordinates,
	fetchSinglePropertyNeighbourhoodReviews,
	fetchSinglePropertyOverview,
	fetchSinglePropertyReviews,
	fetchSinglePropertyTrendingProperties,
	fetchSinglePropertyVicinity,
	fetchSingleRequirement,
	fetchSingleServiceAreasOfOperation,
	fetchSingleServiceCreatorDetails,
	fetchSingleServiceDetails,
	fetchSingleServiceImages,
	fetchSingleServiceMapView,
	fetchSingleServiceOverview,
	fetchSingleServicePageData,
	fetchSingleServiceProvider,
	fetchSingleServiceReviews,
	fetchSingleServiceSpecifications,
	fetchSingleServiceTopServices,
	fetchSingleServiceTrendingServices,
	fetchSingleUserAnalytics,
	fetchSingleUserProfile,
	fetchSingleUserProfileAboutDetails,
	fetchSingleUserProfileCoverImageAndProfilePicture,
	fetchSingleUserProfileFollowersAndFollowings,
	fetchSingleUserProfileGivenReviews,
	fetchSingleUserProfileListings,
	fetchSingleUserProfilePosts,
	fetchSingleUserProfileReviews,
	fetchSingleUserSavedItems,
	fetchSingleUserSavedOFB,
	fetchSingleUserSavedPost,
	fetchSingleUserSavedProperties,
	fetchSingleUserSavedService,
	fetchTopAgentAreas,
	fetchUserChats,
	fetchUserProfileLeads,
	fetchUserProperties,
	followUser,
	genetateAIBoostActivityLogsSummary,
	handleDeleteLeadReminder,
	handleLeadsDetailsStatus,
	loadMoreBusinessDashboardActivityLogsData,
	loadMoreGlobalSearchPosts,
	loadMoreGlobalSearchResults,
	loadMoreNotificationPage,
	loadMoreOfbProperty,
	loadMoreProperties,
	loadMoreSavedOFB,
	loadMoreSavedPosts,
	loadMoreSavedProperties,
	loadMoreSavedServices,
	loadMoreServices,
	loadMoreUserProperties,
	loadMoreUserSavedOFB,
	loadMoreUserSavedPosts,
	loadMoreUserSavedProperties,
	loadMoreUserSavedServices,
	postSwrForBusiness,
	postSwrForUser,
	profileContext,
	publicproperty,
	publicservice,
	publishproperty,
	publishservice,
	removeBusinessProfileAdmin,
	removeReceivedBroadcastFromList,
	removejunkLeadFromList,
	reportPost,
	respondToRequirement,
	saveRequirement,
	searchBusinessProfileOfbProperties,
	searchBusinessProfileProperties,
	searchBusinessProfileServices,
	searchOfbPropertyListings,
	searchPropertyListings,
	searchServiceListings,
	searchUserProperties,
	searchUserPropertyListings,
	sendChatMessage,
	chatRequestAccepted,
	chatRequestDeclined,
	setCurrentChatSettings,
	setMessageReactions,
	setMessageReceipts,
	replaceChatMessage,
	setChatEditing,
	applyMessageEdit,
	setChatListAllCount,
	setChatTyping,
	syncChatListUnread,
	setChatReplyTo,
	setAccountSettingSnackbar,
	setActionForbooms,
	setActivityLogsLoading,
	setAiBoostDetailsToNull,
	setAiBoostFormAdCreativeBrandLogo,
	setAiBoostFormAdCreativeImage,
	setAiBoostFormAdCreativeReferenceImages,
	setAiBoostFormOfflinePayment,
	setAiBoostFormPropertyDetails,
	setAiMetaBoostedListingsFilterStatus,
	setAiMetaBoostedListingsFilterSortField,
	setAiMetaBoostedListingsFilterSortOrder,
	setAiMetaBoostedListingsInitialLoadDone,
	setAiMetaBoostedListingsTriggerNewSearch,
	setAnalyticsTabValue,
	setBottomBuyBeegruPoints,
	setBroadcastForm,
	setBroadcastListFilterPageNumber,
	setBroadcastListInitialLoadDone,
	setBroadcastListLoading,
	setBroadcastListTriggerNewSearch,
	setBudgetAndLeadsLoading,
	setBusinessDashboardAdminLoading,
	setBusinessDashboardAiBoostFormBudget,
	setBusinessDashboardAiBoostFormCustomBudget,
	// setBusinessDashboardAiBoostForm,
	setBusinessDashboardAnalyticsFilterEndDateX,
	setBusinessDashboardAnalyticsFilterGraphDurationX,
	setBusinessDashboardAnalyticsFilterGraphTypeY,
	setBusinessDashboardAnalyticsFilterListingId,
	setBusinessDashboardAnalyticsFilterListingType,
	setBusinessDashboardAnalyticsFilterStartDateX,
	setBusinessDashboardAnalyticsGraphSource,
	setBusinessDashboardAnalyticsLoading,
	setBusinessDashboardBeegruPointTransactionsFilterPageNumber,
	setBusinessDashboardBeegruPointTransactionsInitialLoadDone,
	setBusinessDashboardBeegruPointTransactionsLoading,
	setBusinessDashboardBeegruPointTransactionsTriggerNewSearch,
	setBusinessDashboardBoostsFilterListingType,
	setBusinessDashboardBoostsFilterPageNumber,
	setBusinessDashboardBoostsFilterSortField,
	setBusinessDashboardBoostsFilterSortOrder,
	setBusinessDashboardBoostsFilterStatus,
	setBusinessDashboardBoostsInitialLoadDone,
	setBusinessDashboardBoostsLoading,
	setBusinessDashboardBoostsTriggerNewSearch,
	setBusinessDashboardBroadcastFilterSortField,
	setBusinessDashboardBroadcastFilterStatus,
	setBusinessDashboardBroadcastFilterSortOrder,
	setBusinessDashboardBroadcastTriggerNewSearch,
	setBusinessDashboardCashTransactionsFilterPageNumber,
	setBusinessDashboardCashTransactionsInitialLoadDone,
	setBusinessDashboardCashTransactionsLoading,
	setBusinessDashboardCashTransactionsTriggerNewSearch,
	setBusinessDashboardCurrentScreen,
	setBusinessDashboardLeadsFilterAssignedStatus,
	setBusinessDashboardLeadsFilterListingType,
	setBusinessDashboardLeadsFilterPageNumber,
	setBusinessDashboardLeadsFilterProperty,
	setBusinessDashboardLeadsFilterDateRange,
	setBusinessDashboardLeadsFilterAssignedToUserIds,
	setBusinessDashboardLeadsFilterSortField,
	setBusinessDashboardLeadsFilterSortOrder,
	setBusinessDashboardLeadsFilterStatus,
	setBusinessDashboardLeadsInitialLoadDone,
	setBusinessDashboardLeadsLoading,
	setBusinessDashboardLeadsTriggerNewSearch,
	setBusinessDashboardListingsFilterListingType,
	setBusinessDashboardListingsFilterPageNumber,
	setBusinessDashboardListingsFilterPropertyId,
	setBusinessDashboardListingsFilterSortField,
	setBusinessDashboardListingsFilterSortOrder,
	setBusinessDashboardListingsFilterStatus,
	setBusinessDashboardListingsFilterTransactionType,
	setBusinessDashboardListingsInitialLoadDone,
	setBusinessDashboardListingsLoading,
	setBusinessDashboardListingsTriggerNewSearch,
	setBusinessDashboardPaymentTransactionsFilterPageNumber,
	setBusinessDashboardPaymentTransactionsInitialLoadDone,
	setBusinessDashboardPaymentTransactionsLoading,
	setBusinessDashboardPaymentTransactionsTriggerNewSearch,
	setBusinessDashboardPromotionalEmailsLoading,
	setBusinessDashboardPropertyBroadcastInitialLoadDone,
	setBusinessDashboardPropertyBroadcastTriggerNewSearch,
	setBusinessDashboardPropertyBroadcastsFilterPageNumber,
	setBusinessDashboardReferralsFilterPageNumber,
	setBusinessDashboardReferralsInitialLoadDone,
	setBusinessDashboardReferralsLoading,
	setBusinessDashboardReferralsTriggerNewSearch,
	setBusinessDashboardReviewsFilterPageNumber,
	setBusinessDashboardReviewsFilterSortField,
	setBusinessDashboardReviewsFilterSortOrder,
	setBusinessDashboardReviewsInitialLoadDone,
	setBusinessDashboardReviewsTriggerNewSearch,
	setBusinessDashboardRewardsHistoryFilterPageNumber,
	setBusinessDashboardRewardsHistoryInitialLoadDone,
	setBusinessDashboardRewardsHistoryLoading,
	setBusinessDashboardRewardsHistoryTriggerNewSearch,
	setBusinessDashboardRewardsInitialLoadDone,
	setBusinessDashboardRewardsLoading,
	setBusinessDashboardRewardsTriggerNewSearch,
	setBusinessDashboardSavedItemsFilterListingType,
	setBusinessDashboardSavedItemsFilterPageNumber,
	setBusinessDashboardSavedItemsInitialLoadDone,
	setBusinessDashboardSavedItemsLoading,
	setBusinessDashboardSavedItemsTriggerNewSearch,
	setBusinessDashboardShowContactDetailsLoading,
	setBusinessDashboardUserViewTabValue,
	setBusinessProfileAboutOfficeAddress,
	setBusinessProfileAboutShortDescription,
	setBusinessProfileAboutWebsiteUrl,
	setBusinessProfileAboutYearEstablished,
	setBusinessProfileBrokerage,
	setBusinessProfileEmail,
	setBusinessProfileExpertise,
	setBusinessProfileFAQ,
	setBusinessProfileLanguages,
	setBusinessProfileLicencesAndCertificates,
	setBusinessProfileNoOfEmployees,
	setBusinessProfilePhoneCountryCode,
	setBusinessProfilePhoneNumber,
	setBusinessProfileServicesOfferedTags,
	setBusinessProfileSnackbar,
	setCRMAPIKeyField,
	setCRMAddNewHeaderField,
	setCRMApiMethod,
	setCRMChannelIDField,
	setCRMEmailField,
	setCRMEnquiredAtField,
	setCRMHeadersKey,
	setCRMHeadersValue,
	setCRMLeadIDField,
	setCRMLeadSourceField,
	setCRMName,
	setCRMNameField,
	setCRMNotesField,
	setCRMPayloadType,
	setCRMPhoneNumberField,
	setCRMProjectNameField,
	setCRMRemoveHeaderField,
	setCRMStatusField,
	setCRMWebhookApiKey,
	setCRMWebhookURL,
	setChannelId,
	setChatListFilterPageNumber,
	setChatListInitialLoadDone,
	setChatListTab,
	setChatListTriggerNewSearch,
	setChatMessagesFilterPageNumber,
	setChatMessagesInitialLoadDone,
	setChatMessagesLoading,
	setChatMessagesTriggerNewSearch,
	setChatScreen,
	setCreateBoost,
	setCreateNePropertyMinBalconies,
	setCreateNePropertyMinSuperBuiltUpArea,
	setCreateNewPropertyAge,
	setCreateNewPropertyAvailabilty,
	setCreateNewPropertyBrokerLicensePermitName,
	setCreateNewPropertyBrokerLicensePermitNumber,
	setCreateNewPropertyCategoryType,
	setCreateNewPropertyCurrency,
	setCreateNewPropertyCurrentPage,
	setCreateNewPropertyDefaultLocation,
	setCreateNewPropertyFloorNo,
	setCreateNewPropertyFurnishing,
	setCreateNewPropertyIssuingAuthority,
	setCreateNewPropertyLandArea,
	setCreateNewPropertyLandAreaUnit,
	setCreateNewPropertyLandFacing,
	setCreateNewPropertyMaxBalconies,
	setCreateNewPropertyMaxBathrooms,
	setCreateNewPropertyMaxBedrooms,
	setCreateNewPropertyMaxCarpetArea,
	setCreateNewPropertyMaxFloors,
	setCreateNewPropertyMaxPrice,
	setCreateNewPropertyMaxSuperBuiltUpArea,
	setCreateNewPropertyMinBathrooms,
	setCreateNewPropertyMinBedrooms,
	setCreateNewPropertyMinCarpetArea,
	setCreateNewPropertyMinPrice,
	setCreateNewPropertyNoOfSeats,
	setCreateNewPropertyNoOfUnits,
	setCreateNewPropertyOverview,
	setCreateNewPropertyPermitNumber,
	setCreateNewPropertyPlotDimensions,
	setCreateNewPropertySecurityDeposit,
	setCreateNewPropertySubType,
	setCreateNewPropertySuperBuiltUpAreaUnit,
	setCreateNewPropertyTransactionType,
	setCreateNewPropertyType,
	setCreateNewPropertyUnitFacing,
	setCreateNewPropertyUploadImages,
	setCreateNewServiceCategory,
	setCreateNewServiceCurrentPage,
	setCreateNewServiceDefaultLocation,
	setCreateNewServiceMaxPrice,
	setCreateNewServiceMinPrice,
	setCreateNewServiceOtherSubType,
	setCreateNewServiceProviderName,
	setCreateNewServiceShowPrice,
	setCreateNewServiceSubType,
	setCreateNewServiceType,
	setCreateNewServiceUploadImages,
	setCreateNewePropertyPossessionDate,
	setCreatePropertySelectedImagesUrl,
	setCurrentChat,
	setDataBeforeEdit,
	setDefaultProfileContext,
	setFaqSearchResults,
	setFilterSelectedCampaignId,
	setFilterSelectedPlatform,
	setHomeLoading,
	setHomeLocation,
	setHomePageBusinessProfileLoading,
	setHomePagePropertiesLoading,
	setImageCategory,
	setImagesIndex,
	setIsLoading,
	setIsSearching,
	setLanguage,
	setLeadDetailsReminder,
	setListingTabValue,
	setLoading,
	setLoginFlowGlobalStateActionCallbackUrl,
	setLoginFlowGlobalStateActionSignIn,
	setLoginFlowGlobalStateActionSignOut,
	setLoginFlowGlobalStateActionSignUp,
	setLoginFlowGlobalStateModalOpen,
	setLoginFlowGlobalStateReferrerCountryCode,
	setLoginFlowGlobalStateReferrerDisplayName,
	setLoginFlowGlobalStateReferrerFirstName,
	setLoginFlowGlobalStateReferrerLastName,
	setLoginFlowGlobalStateReferrerPhone,
	setLoginFlowGlobalStateStageTriggerSource,
	setLoginFlowGlobalStateUiSnackbarMessage,
	setLoginFlowGlobalStateUiSnackbarOpen,
	setLoginFlowGlobalStateUiSnackbarType,
	setLoginFlowGlobalStateUiType,
	setLoginFlowGlobalStateUserCountryCode,
	setLoginFlowGlobalStateUserDisplayName,
	setLoginFlowGlobalStateUserFirstName,
	setLoginFlowGlobalStateUserHasReferralCode,
	setLoginFlowGlobalStateUserIsSignIn,
	setLoginFlowGlobalStateUserIsSignUp,
	setLoginFlowGlobalStateUserIsSignedIn,
	setLoginFlowGlobalStateUserLastName,
	setLoginFlowGlobalStateUserOTP,
	setLoginFlowGlobalStateUserPhone,
	setLoginFlowGlobalStateUserReferralCode,
	setLoginFlowGlobalStateUserUserId,
	setMetaAiBoostActivityLogsLoading,
	setMetaAiBoostAdPreviewsFilterPageNumberCount,
	setMetaAiBoostDetailsSelectedCampaign,
	setMetaCreativesLoading,
	setMetricsLoading,
	setMyRequirementsFilterPageNumber,
	setMyRequirementsFilterSortField,
	setMyRequirementsFilterSortOrder,
	setMyRequirementsFilterStatus,
	setMyRequirementsInitialLoadDone,
	setMyRequirementsLoading,
	setMyRequirementsSelectedRequirementLoading,
	setMyRequirementsTriggerNewSearch,
	setNerLastSearchedTerm,
	setNerSearchTerm,
	setOnBoardingDetails,
	setOpenChatModal,
	setOpenCreateRequirementModal,
	setOpenPostModal,
	setPostPropertyWithUploadToolSnackbarError,
	setPreviousPropertyData,
	setPreviousServiceData,
	setProfileContext,
	setPropertyIdForCampaignDetails,
	setPropertyImagesUploadCompleted,
	setPropertyIsImagesUploading,
	setPropertySnackbar,
	setRecommendedPropertiesInitialLoadDone,
	setRecommendedPropertiesTriggerNewSearch,
	setRequirementsFeedFilterLocation,
	setRequirementsFeedFilterPageNumber,
	setRequirementsFeedFilterPropertyCategory,
	setRequirementsFeedFilterTransactionType,
	setRequirementsFeedInitialLoadDone,
	setRequirementsFeedLoading,
	setRequirementsFeedTriggerNewSearch,
	setPropertyTranslations,
	setBbmPushNotificationTemplate,
	setBbmScheduledPushNotificationLog,
	setNotificationQueue,
	setSaveTabValue,
	setSavedIsPublic,
	setSearchAnimationDetails,
	setSearchFilterMetrices,
	setSearchLeadsResponseBoostIds,
	setSearchOFBProperties,
	setSearchProperties,
	setSearchResultsPageNumber,
	setSearchServices,
	setSearchSortBy,
	setSectionToEdit,
	setServiceImagesUploadCompleted,
	setServiceIsImagesUploading,
	setServiceSnackbar,
	setSingleLeadData,
	setSinglePropertyAbout,
	setSinglePropertyAboutLocation,
	setSinglePropertyAge,
	setSinglePropertyAmenities,
	setSinglePropertyAvailabilty,
	setSinglePropertyCategoryType,
	setSinglePropertyCurrency,
	setSinglePropertyDescription,
	setSinglePropertyDeveloperName,
	setSinglePropertyDeveloperSlug,
	setSinglePropertyEstablishedYear,
	setSinglePropertyFloorNo,
	setSinglePropertyFurnishing,
	setSinglePropertyLandArea,
	setSinglePropertyLandFacing,
	setSinglePropertyManualOverview,
	setSinglePropertyMaxBalconies,
	setSinglePropertyMaxBathrooms,
	setSinglePropertyMaxBedrooms,
	setSinglePropertyMaxCarpetArea,
	setSinglePropertyMaxFloors,
	setSinglePropertyMaxPrice,
	setSinglePropertyMaxSuperBuiltUpArea,
	setSinglePropertyMinBalconies,
	setSinglePropertyMinBathrooms,
	setSinglePropertyMinBedrooms,
	setSinglePropertyMinCarpetArea,
	setSinglePropertyMinPrice,
	setSinglePropertyMinSuperBuiltUpArea,
	setSinglePropertyNoOfSeats,
	setSinglePropertyNoOfUnits,
	setSinglePropertyOtherPlotDimensions,
	setSinglePropertyOverview,
	setSinglePropertyPlotDimensions,
	setSinglePropertyPossessionDate,
	setSinglePropertySecurityDeposit,
	setSinglePropertySubType,
	setSinglePropertyTags,
	setSinglePropertyTransactionType,
	setSinglePropertyType,
	setSinglePropertyUnitFacing,
	setSinglePropertyVicinity,
	setSingleServiceAreasOfOperation,
	setSingleServiceCategory,
	setSingleServiceLocationCoordinates,
	setSingleServiceLocationPincode,
	setSingleServiceLocationTitle,
	setSingleServiceMaxPrice,
	setSingleServiceMinPrice,
	setSingleServiceOtherSubtype,
	setSingleServiceOverview,
	setSingleServiceProviderDescription,
	setSingleServiceProviderEstablishedYear,
	setSingleServiceProviderName,
	setSingleServiceShowPrice,
	setSingleServiceSpecification,
	setSingleServiceSubtype,
	setSingleServiceTags,
	setSingleServiceType,
	setStartBoost,
	setTabValue,
	setThemeReducer,
	setTransactionType,
	setUserLoading,
	setUserLocation,
	setUserProfileSnackbar,
	setUserSavedItemsFilterListingType,
	setUserSavedItemsFilterPageNumber,
	setUserSavedItemsInitialLoadDone,
	setUserSavedItemsLoading,
	setUserSavedItemsTriggerNewSearch,
	setUsersSettingsCurrentScreen,
	storeleads,
	switchBusinessDashboardContantDetails,
	switchBusinessDashboardPromotionalEmails,
	trackContactAction,
	unfollowUser,
	unsaveRequirement,
	updateBeegrupointsAfterPurchase,
	updateBlasts,
	updateBooms,
	updateBoost,
	updateBroadcastReadStatus,
	updateBusinessDashboardLeadsAssignedTo,
	updateBusinessProfileAdminRole,
	updateBusinessProfileKycInfo,
	updateCookieConsent,
	updateCurrency,
	updateFeatureDiscoveryTracker,
	updateLocationProperty,
	updateNofEmployees,
	updateNotificationViewed,
	updateNotificationsViewed,
	updatePersonalInfo,
	updatePropertyImage,
	updateReduxSession,
	updateRequirement,
	updateRequirementStatus,
	updateSearchFilterActiveOptions,
	updateSearchFilterApplied,
	updateSearchFilterIsAccordionOpen,
	updateSearchFilterSelectedOptions,
	updateSearchFilterVisibility,
	updateServiceImage,
	updateServiceLocation,
	updateUserKycInfo,
	updatedPublishedProperties,
	updatedPublishedServices,
	updateleads,
	SetSalesSupportInvestment,
	SetPropertyClosure,
} from "./reducers";

import {
	account_settings_page,
	ai_boost_google_ad,
	ai_boost_google_ad_group,
	ai_boost_google_campaign,
	ai_boost_meta_campaign,
	ai_boosts,
	broadcast,
	broadcast_data,
	broadcast_recipient,
	business_dashboard,
	chat,
	chat_states,
	homePage,
	localities,
	my_requirements,
	ner_search_states,
	new_property_data,
	new_service_data,
	notifications_page,
	on_boarding_title,
	profile_context,
	property_reviews_page,
	redux_session,
	requirement,
	requirements_feed,
	saved_posts_list,
	search_filter_metrices,
	service_reviews_page,
	single_business_profile,
	single_property_page,
	single_service_page,
	single_user_profile,
	team_invite
} from "./sub-state-data-empty/sub-state-data-empty";

import {
	account_setting_loading,
	accountsetting_snackbar,
	boost,
	business_profile_loading,
	business_profile_snackbar,
	feature_discovery_tracker,
	home_loading,
	login_flow_global_state,
	looking_for,
	notifications_loading,
	property_loading,
	property_snackbar,
	service_loading,
	service_snackbar,
	test_client_crm_integration_webhooks,
	user_profile_loading,
	user_profile_snackbar,
} from "./sub-state-data/sub-state-data";
/*

& Now we'll describe a global slice for our global state. Using the createSlice() function, we avoid the all-so-common mistake of trying to mutate the immutable redux store directly.

* Reducers are pure functions that take the current state and an action, and return a new state. But since createSlice() uses the Immer library which tracks changes on a draft state before returning a new state, we can directly mutate the state in the reducer.

* It is possible to create various slices for different parts of the state, but we'll skip over this detail for now as it will add a lot of time to the development cycle.

^ All reducers for this app are described in the redux-magic/reducers.ts file.

*/

export const globalSlice = createSlice({
	/*

    * Name of the slice. This is the key used to access the slice in the store.

    */

	name: "globalState",

	/*

    * Initial state of the slice. This is the state that will be used before any other redux magic happens.
    ! Changed the initial state to an empty object to ensure app is not data heavy during hydration.
    ! This may cause some code to break. Please call the appropriate thunk in getServerSideProps() to hydrate the state.

  */

	// initialState: defaultStateData as StateInterface,
	initialState: {
		homePage: homePage,
		single_user_profile: single_user_profile,
		single_business_profile: single_business_profile,
		property_reviews_page: property_reviews_page,
		single_service_page: single_service_page,
		account_settings_page: account_settings_page,
		single_property_page: single_property_page,
		service_reviews_page: service_reviews_page,
		saved_posts_list: saved_posts_list,
		home_loading: home_loading,
		property_loading: property_loading,
		property_snackbar: property_snackbar,
		service_snackbar: service_snackbar,
		business_profile_snackbar: business_profile_snackbar,
		service_loading: service_loading,
		business_profile_loading: business_profile_loading,
		looking_for: looking_for,
		user_profile_loading: user_profile_loading,
		notifications_page: notifications_page,
		notifications_loading: notifications_loading,
		account_setting_loading: account_setting_loading,
		accountsetting_snackbar: accountsetting_snackbar,
		on_boarding_title: on_boarding_title,
		user_profile_snackbar: user_profile_snackbar,
		redux_session: redux_session,
		profile_context: profile_context,
		boost: boost,
		search_filter_metrices: search_filter_metrices,
		new_property_data: new_property_data,
		new_service_data: new_service_data,
		business_dashboard: business_dashboard,
		login_flow_global_state: login_flow_global_state,
		localities: localities,
		broadcast: broadcast,
		broadcast_recipient: broadcast_recipient,
		broadcast_data: broadcast_data,
		chat: chat,
		chat_states: chat_states,
		ai_boosts: ai_boosts,
		ai_boost_meta_campaign: ai_boost_meta_campaign,
		ai_boost_google_campaign: ai_boost_google_campaign,
		ai_boost_google_ad_group: ai_boost_google_ad_group,
		ai_boost_google_ad: ai_boost_google_ad,
		feature_discovery_tracker: feature_discovery_tracker,
		test_client_crm_integration_webhooks: test_client_crm_integration_webhooks,
		requirement: requirement,
		requirements_feed: requirements_feed,
		my_requirements: my_requirements,
		open_create_requirement_modal: false,

		/*

		! Please do not push test version of state generator function to production!

		*/
		search_filters_state: generateInitialSearchFiltersReduxState(),
		ner_search_states: ner_search_states,
		team_invite: team_invite,
	},

	/*

    * Reducers. These are the functions that will be used to update the state.

    ^ All reducers for this app are described in the redux-magic/reducers.ts file.

    */

	reducers: {
		addNewNoteToLeadActivityLogs,
		setRecommendedPropertiesInitialLoadDone,
		setAiBoostFormOfflinePayment,
		setMetaCreativesLoading,
		fetchAiBoostAllBoostLists,
		setRecommendedPropertiesTriggerNewSearch,
		setAiMetaBoostedListingsFilterStatus,
		setAiMetaBoostedListingsFilterSortField,
		setAiMetaBoostedListingsFilterSortOrder,
		setPropertyIdForCampaignDetails,
		setPreviousServiceData,
		changeMe,
		setThemeReducer,
		fetchSingleProperty,
		CreateNewPost,
		setImageCategory,
		setLanguage,
		setLoading,
		setImagesIndex,
		fetchSingleBusinessProfile,
		fetchGlobalSearchResults,
		loadMoreGlobalSearchResults,
		loadMoreGlobalSearchPosts,
		fetchPropertyReviewsPageData,
		fetchSingleUserProfile,
		fetchBoostPostPageData,
		setServiceIsImagesUploading,
		fetchBoostBusinessProfilePageData,
		fetchBoostUserProfilePageData,
		fetchBoostPropertyPageData,
		fetchSingleServicePageData,
		fetchSingleServiceImages,
		fetchSingleServiceDetails,
		fetchSingleServiceOverview,
		fetchSingleServiceSpecifications,
		fetchSingleServiceProvider,
		fetchSingleServiceAreasOfOperation,
		fetchSingleServiceMapView,
		fetchSingleServiceReviews,
		fetchSingleServiceCreatorDetails,
		fetchSingleServiceTopServices,
		fetchSingleServiceTrendingServices,
		setSingleServiceCategory,
		setSingleServiceType,
		setSingleServiceSubtype,
		setSingleServiceOtherSubtype,
		setSingleServiceTags,
		setSingleServiceShowPrice,
		setSingleServiceMinPrice,
		setSingleServiceMaxPrice,
		setSingleServiceOverview,
		setAiBoostFormAdCreativeImage,
		setSingleServiceSpecification,
		setSingleServiceProviderName,
		setSingleServiceProviderEstablishedYear,
		setSingleServiceProviderDescription,
		setSingleServiceAreasOfOperation,
		setSingleServiceLocationTitle,
		setSingleServiceLocationPincode,
		setSingleServiceLocationCoordinates,
		setSectionToEdit,
		setDataBeforeEdit,
		fetchNeighbourhoodReviewsPageData,
		fetchServiceReviewsPageData,
		fetchBoostServicePageData,
		fetchHomePageData,
		fetchNotificationPage,
		loadMoreNotificationPage,
		fetchRealtimeNotification,
		updateNotificationViewed,
		updateNotificationsViewed,
		setTabValue,
		setSaveTabValue,
		setListingTabValue,
		setUserLocation,
		addAdminUserDetails,
		deleteAdminUserDetails,
		UpdateBusinessAbout,
		UpdateBusinessBrokerage,
		UpdateBusinessExpertise,
		UpdateBusinessLanguages,
		UpdateBusinessServices,
		UpdateBusinessFAQs,
		AddSepcialOfferDetailsForBusinessProfile,
		UpdateBusinessLicences,
		fetchFaqs,
		setFaqSearchResults,
		fetchSingleFaq,
		FaqAddUpvote,
		FaqAddDownvote,
		FaqRemoveUpvote,
		FaqRemoveDownvote,
		SetDefaultLookingFor,
		SetDefaultLocationBoost,
		SetDefaultLocation,
		UpdateUserAboutDetails,
		UpdateUserSkills,
		addExperienceForUser,
		AddUserCourses,
		AddUserLanguage,
		AddingBeegruPointsForShareService,
		AddHonorsAndAwardsDetailsForUser,
		AddLicenseAndCertificationDetailsForUser,
		AddSaveEntityBusinessProfile,
		AddSaveEntityUserProfile,
		UpdateServiceAreasOfOperation,
		UpdateServiceOverView,
		UpdateServiceDetails,
		UpdateServiceSpecification,
		UpdateServiceProvider,
		followUser,
		unfollowUser,
		UpdatePropertyDetails,
		UpdatePropertyRegulatoryInfo,
		UpdateConfigAndArea,
		UpdateAboutDeveloperProperty,
		UpdateAboutLocationProperty,
		UpdateAboutProperty,
		UpdateAmenities,
		UpdateOverView,
		UpdateVicinity,
		setCreateBoost,
		setStartBoost,
		EmployeeRequest,
		acceptEmployeeRequest,
		deleteEmployeeRequest,
		updateBoost,
		cancelBoost,
		fetchReceiptPageData,
		fetchAccountSettingsPageData,
		fetchAccountSettingsProfileKycInfo,
		addPropertyImages,
		createNewProperty,
		CreateNewService,
		Setintro,
		KycProfileTypes,
		updatePropertyImage,
		cropPropertyImage,
		deletePropertyImage,
		deleteServiceImage,
		BusinessDashboardCreateNewSubscription,
		BusinessDashboardRenewSubscription,
		BusinessDashboardCancelSubscription,
		CreateNewSubscription,
		RenewSubscription,
		CancelSubscription,
		ProfileToUpgrade,
		ProfileToUpgradeId,
		ProfileToUpgradeType,
		deletePropertyDetails,
		updateUserKycInfo,
		updateBusinessProfileKycInfo,
		addServiceImages,
		updateServiceImage,
		cropServiceImage,
		updatePersonalInfo,
		updateLocationProperty,
		updateServiceLocation,
		addProfilePicture,
		createNewBusinessProfile,
		createNewOFBProperty,
		deletePropertyOFBDetails,
		createNewOFBPropertyUser,
		CreateNewComments,
		deletePropertyOFBUsers,
		addCoverImage,
		updateBooms,
		RemoveBooms,
		updateBlasts,
		addBusinessProfilePicture,
		CreateNewPostUser,
		CreateNewCommentsUserPost,
		deletePostUser,
		ReplyToComment,
		deleteServiceDetails,
		setProfileContext,
		setActionForbooms,
		profileContext,
		bookmark,
		reportPost,
		postSwrForBusiness,
		postSwrForUser,
		commentSwr,
		setIsSearching,
		setSearchResultsPageNumber,
		setIsLoading,
		publicproperty,
		fetchMetaAiBoostsAdCreatives,
		publishproperty,
		publicservice,
		publishservice,
		OnBoarding,
		updateNofEmployees,
		setSavedIsPublic,
		fetchSinglePost,
		storeleads,
		deleteDesktopLeads,
		deleteMobileLeads,
		updateleads,
		businessProfileListTabView,
		deleteBusinessProfilePicture,
		deleteUserProfilePicture,
		deleteUserCoverImage,
		setSearchProperties,
		setSearchServices,
		setSearchOFBProperties,
		CreateNewReview,
		loadMoreProperties,
		loadMoreServices,
		loadMoreOfbProperty,
		loadMoreSavedProperties,
		loadMoreSavedOFB,
		loadMoreUserSavedProperties,
		loadMoreUserSavedServices,
		loadMoreUserSavedPosts,
		loadMoreUserSavedOFB,
		loadMoreSavedServices,
		loadMoreSavedPosts,
		loadMoreUserProperties,
		searchPropertyListings,
		searchUserPropertyListings,
		changeRecievePromotionalEmails,
		changeAutoplayVideos,
		changeDefaultVideoQuality,
		CreateNewBugReport,
		CreateNewReport,
		UpdateBusinessProfileShortDescription,
		UpdateBusinessProfilecountry_code,
		UpdateBusinessProfilePhone,
		UpdateBusinessProfileEmail,
		UpdateBusinessProfileEstDate,
		UpdateBusinessProfileWebsite,
		UpdateBusinessProfileOfficeAddresses,
		setHomeLocation,
		setHomeLoading,
		fetchHomePageHotPropertiesData,
		fetchHomePageFeaturedPropertiesData,
		fetchHomePageTopServicesData,
		// fetchHomePageTrendingServicesData,
		fetchHomePageTopUsersData,
		// fetchHomePageTrendingUsersData,
		fetchHomePageTopBusinessProfilesData,
		fetchHomePageTopDevelopersData,
		// fetchHomePageTrendingBusinessProfilesData,
		fetchSingleUserProfileCoverImageAndProfilePicture,
		fetchSingleUserProfileFollowersAndFollowings,
		fetchSingleUserProfileAboutDetails,
		fetchSingleUserProfileListings,
		fetchSingleUserProfileReviews,
		fetchSingleUserSavedProperties,
		fetchSingleUserAnalytics,
		fetchSingleUserSavedPost,
		fetchSingleUserSavedService,
		fetchSingleUserSavedOFB,
		fetchBusinessProfileImages,
		fetchBusinessDashboardProfileData,
		fetchHomepageDashboardStats,
		updateBroadcastReadStatus,
		fetchBusinessProfileAboutDetails,
		fetchBusinessProfileFollowerAndFollowing,
		fetchBusinessProfileServiceOffered,
		fetchBusinessProfileExpertise,
		fetchBusinessProfileBrokerage,
		fetchBusinessProfileFaqs,
		fetchBusinessProfileLanguages,
		fetchBusinessProfileLicencesAndCertificates,
		fetchBusinessProfileNoOfEmployees,
		fetchBusinessProfileListingProperty,
		fetchBusinessProfileReviews,
		setAnalyticsTabValue,
		fetchBusinessProfileListingService,
		fetchBusinessProfileListingOFB,
		fetchBusinessProfileLeads,
		fetchBusinessProfileSavedProperty,
		fetchBusinessProfileSavedService,
		fetchBusinessProfileSavedOFB,
		fetchBusinessProfileSavedPost,
		fetchBusinessProfileAnalyticsProperty,
		fetchBusinessProfileAnalyticsService,
		fetchBusinessProfileAnalyticsPost,
		fetchBusinessProfileAnalyticsOFBs,
		fetchBusinessProfileAdminsDetailsAndEmployeeRequest,
		fetchPropertyDataReviewsPageData,
		fetchPropertyUserDataReviewsPageData,
		fetchServiceDataReviewsPageData,
		fetchServiceUserDataReviewsPageData,
		fetchAccountSettingsUserData,
		fetchAccountSettingsUserCashtransactions,
		fetchAccountSettingsUserBeegruPointstransactions,
		fetchAccountSettingsSubscriptionsPlans,
		fetchAccountSettingsSubscriptions,
		fetchAccountSettingsFilesCount,
		fetchSinglePropertyDetails,
		fetchDevelopers,
		fetchNearbyProperties,
		fetchSinglePropertyConfigAndArea,
		setSinglePropertyTransactionType,
		setSinglePropertyCategoryType,
		setSinglePropertyType,
		setSinglePropertyMinPrice,
		setSinglePropertyMaxPrice,
		setSinglePropertySecurityDeposit,
		setSinglePropertyCurrency,
		setSinglePropertyAvailabilty,
		setSinglePropertyPossessionDate,
		setSinglePropertyTags,
		setSinglePropertyUnitFacing,
		setSinglePropertyLandFacing,
		setSinglePropertyAge,
		setSinglePropertyFurnishing,
		setSinglePropertyPlotDimensions,
		setSinglePropertyOtherPlotDimensions,
		setSinglePropertyLandArea,
		setSinglePropertyMinSuperBuiltUpArea,
		setSinglePropertyMaxSuperBuiltUpArea,
		setSinglePropertyMinCarpetArea,
		setSinglePropertyMaxCarpetArea,
		setSinglePropertyMinBedrooms,
		setSinglePropertyMaxBedrooms,
		setSinglePropertyMinBathrooms,
		setSinglePropertyMaxBathrooms,
		setSinglePropertyMinBalconies,
		setSinglePropertyMaxBalconies,
		setSinglePropertyMaxFloors,
		setSinglePropertyFloorNo,
		setSinglePropertyNoOfUnits,
		setSinglePropertyNoOfSeats,
		setSinglePropertySubType,
		setSinglePropertyAbout,
		setSinglePropertyDeveloperName,
		setSinglePropertyEstablishedYear,
		setSinglePropertyAboutLocation,
		setSinglePropertyDescription,
		setSinglePropertyVicinity,
		fetchAboutSingleProperty,
		fetchSinglePropertyCreator,
		fetchSinglePropertyAboutLocation,
		fetchSinglePropertyAmenities,
		setSinglePropertyAmenities,
		fetchSinglePropertyDeveloper,
		fetchSinglePropertyImages,
		fetchSinglePropertyLocationCoordinates,
		fetchSinglePropertyOverview,
		setSinglePropertyOverview,
		fetchSinglePropertyReviews,
		fetchSinglePropertyVicinity,
		fetchSinglePropertyTrendingProperties,
		fetchSinglePropertyHotProperties,
		fetchSinglePropertyNeighbourhoodReviews,
		setBusinessProfileAboutShortDescription,
		setBusinessProfileServicesOfferedTags,
		setBusinessProfileExpertise,
		setBusinessProfileBrokerage,
		setBusinessProfileLicencesAndCertificates,
		setBusinessProfileNoOfEmployees,
		setBusinessProfileFAQ,
		setBusinessProfileLanguages,
		setBusinessProfileAboutYearEstablished,
		setBusinessProfileAboutOfficeAddress,
		setBusinessProfileAboutWebsiteUrl,
		setBusinessProfilePhoneCountryCode,
		setBusinessProfilePhoneNumber,
		setBusinessProfileEmail,
		deleteReview,
		AllowcopyProperty,
		ShowContactDetailsProperty,
		ShowContactDetailsService,
		addingbeegrupointsshareproperty,
		fetchSingleUserProfilePosts,
		LoadingMoreUserProfilePosts,
		fetchBusinessProfilePosts,
		LoadingMoreBusinessProfilePosts,
		setHomePageBusinessProfileLoading,
		searchUserProperties,
		setPropertySnackbar,
		setServiceSnackbar,
		setHomePagePropertiesLoading,
		searchBusinessProfileProperties,
		searchBusinessProfileOfbProperties,
		searchOfbPropertyListings,
		searchBusinessProfileServices,
		searchServiceListings,
		setBusinessProfileSnackbar,
		setUserLoading,
		fetchSingleUserProfileGivenReviews,
		LoadingMoreUserGivenReviews,
		LoadingMoreUserReviews,
		fetchBusinessProfileGivenReviews,
		LoadingMoreBusinessProfileGivenReviews,
		LoadingMoreBusinessProfileReviews,
		fetchBusinessProfileSubscription,
		setAccountSettingSnackbar,
		setTransactionType,
		setOnBoardingDetails,
		fetchOnBoardingBusinessTitle,
		setUserProfileSnackbar,
		fetchUserProfileLeads,
		NewEmployeeRquestOnBoarding,
		setBottomBuyBeegruPoints,
		setDefaultProfileContext,
		updateReduxSession,
		UpdateReduxSessionUserFields,
		FetchMoreBusinessProfiles,
		fetchBusinessProfilePublishedProperties,
		updatedPublishedProperties,
		fetchBusinessProfilePublishedServices,
		updatedPublishedServices,
		createNewBroadcast,
		fetchRealtimeNewChatMessage,
		sendChatMessage,
		chatRequestAccepted,
		chatRequestDeclined,
		setCurrentChatSettings,
		setMessageReactions,
		setMessageReceipts,
		replaceChatMessage,
		setChatEditing,
		applyMessageEdit,
		setChatListAllCount,
		setChatTyping,
		syncChatListUnread,
		setChatReplyTo,
		fetchHomePageHotPropertiesBuyLocalStorageData,
		fetchHomePageHotPropertiesRentLocalStorageData,
		fetchHomePageHotPropertiesOfbLocalStorageData,
		fetchAccountSettingsRewardtransactions,
		fetchOneTimeRewards,
		fetchRecurringRewards,
		updateSearchFilterActiveOptions,
		updateSearchFilterSelectedOptions,
		updateSearchFilterVisibility,
		updateSearchFilterApplied,
		updateSearchFilterIsAccordionOpen,
		setSearchFilterMetrices,
		CreateNewView,
		setSearchAnimationDetails,
		fetchSearchData,
		fetchPropertyCardData,
		setCreateNewPropertyTransactionType,
		setCreateNewPropertyCurrentPage,
		setCreateNewPropertyCategoryType,
		setCreateNewPropertyType,
		setCreateNewPropertySubType,
		setCreateNewPropertyMinPrice,
		setCreateNewPropertyMaxPrice,
		setCreateNewPropertySecurityDeposit,
		setCreateNewPropertyCurrency,
		setCreateNewPropertyAvailabilty,
		setCreateNewePropertyPossessionDate,
		setCreateNewPropertyUnitFacing,
		setCreateNewPropertyLandFacing,
		setCreateNewPropertyAge,
		setCreateNewPropertyPlotDimensions,
		setCreateNewPropertyOverview,
		setCreateNewPropertyPermitNumber,
		setCreateNewPropertyIssuingAuthority,
		setCreateNewPropertyBrokerLicensePermitNumber,
		setCreateNewPropertyBrokerLicensePermitName,
		setCreateNewPropertyFurnishing,
		setCreateNewPropertyLandArea,
		setCreateNewPropertyMaxBalconies,
		setCreateNewPropertyMaxBathrooms,
		setCreateNewPropertyMaxBedrooms,
		setCreateNewPropertyMaxCarpetArea,
		setCreateNewPropertyMaxFloors,
		setCreateNewPropertyMaxSuperBuiltUpArea,
		setCreateNePropertyMinBalconies,
		setCreateNewPropertyMinBathrooms,
		setCreateNewPropertyMinBedrooms,
		setCreateNewPropertyMinCarpetArea,
		setCreateNePropertyMinSuperBuiltUpArea,
		setCreateNewPropertyNoOfUnits,
		setCreateNewPropertyNoOfSeats,
		setCreateNewPropertyFloorNo,
		setCreateNewPropertyDefaultLocation,
		setCreateNewPropertyUploadImages,
		setPropertyImagesUploadCompleted,
		setServiceImagesUploadCompleted,
		setCreatePropertySelectedImagesUrl,
		setCreateNewPropertyLandAreaUnit,
		setCreateNewPropertySuperBuiltUpAreaUnit,
		UpdateAiOverView,
		createNewPropertyWithUploadTool,
		setPostPropertyWithUploadToolSnackbarError,
		setCreateNewServiceType,
		setCreateNewServiceSubType,
		setCreateNewServiceOtherSubType,
		setCreateNewServiceCategory,
		setCreateNewServiceDefaultLocation,
		setCreateNewServiceUploadImages,
		setCreateNewServiceMinPrice,
		setAiBoostFormAdCreativeReferenceImages,
		setCreateNewServiceMaxPrice,
		setCreateNewServiceShowPrice,
		setCreateNewServiceProviderName,
		changeDataTuning,
		createNewServiceWithUploadTool,
		setCreateNewServiceCurrentPage,
		UpdatePropertyTitle,
		// PropertyBoost
		SetPropertyBoostMobileStepState,
		SetPropertyBoostSnackState,
		SetPropertyBoostModalState,
		SetPropertyBoostedByState,
		SetPropertyBoostDataState,
		SetPropertyBoostDetailState,
		SetPropertyBoostLocationState,
		SetPropertyBoostPointsState,
		SetPropertyLoadingState,
		CreatePropertyBoostState,
		CancelPropertyBoostState,
		UpdateBusinessProfileLeadsStatus,
		UpdateBusinessProfileLeadsNotes,
		UpdateUserProfileLeadsNotes,
		UpdateUserProfileLeadsStatus,
		UpdateServiceTitle,
		setSinglePropertyManualOverview,
		updateBeegrupointsAfterPurchase,
		fetchBusinessDashboardLeadsDesktop,
		setBusinessDashboardCurrentScreen,
		setBusinessDashboardShowContactDetailsLoading,
		setBusinessDashboardPromotionalEmailsLoading,
		setBusinessDashboardLeadsTriggerNewSearch,
		setBusinessDashboardLeadsInitialLoadDone,
		fetchLeadsById,
		fetchBusinessDashboardLeadsMobile,
		fetchBusinessDashboardSavedItems,
		setBusinessDashboardSavedItemsFilterListingType,
		setBusinessDashboardSavedItemsFilterPageNumber,
		setBusinessDashboardSavedItemsInitialLoadDone,
		setBusinessDashboardSavedItemsLoading,
		setBusinessDashboardSavedItemsTriggerNewSearch,
		setBusinessDashboardLeadsFilterStatus,
		setBusinessDashboardLeadsFilterProperty,
		setBusinessDashboardLeadsFilterDateRange,
		setBusinessDashboardLeadsFilterAssignedToUserIds,
		setBusinessDashboardLeadsFilterListingType,
		setBusinessDashboardLeadsFilterSortField,
		setBusinessDashboardLeadsFilterSortOrder,
		setBusinessDashboardLeadsFilterPageNumber,
		setBusinessDashboardReviewsInitialLoadDone,
		setBusinessDashboardReviewsTriggerNewSearch,
		setBusinessDashboardReviewsFilterPageNumber,
		fetchBusinessDashboardReviewsMobile,
		setBusinessDashboardReviewsFilterSortField,
		setBusinessDashboardReviewsFilterSortOrder,
		setBusinessDashboardBeegruPointTransactionsLoading,
		setBusinessDashboardBeegruPointTransactionsTriggerNewSearch,
		setBusinessDashboardBeegruPointTransactionsInitialLoadDone,
		setBusinessDashboardBeegruPointTransactionsFilterPageNumber,
		fetchBusinessDashboardBeegruPointTransactions,
		setBusinessDashboardCashTransactionsLoading,
		setBusinessDashboardCashTransactionsTriggerNewSearch,
		setBusinessDashboardCashTransactionsInitialLoadDone,
		setBusinessDashboardCashTransactionsFilterPageNumber,
		fetchBusinessDashboardCashTransactions,
		setBusinessDashboardPaymentTransactionsLoading,
		setBusinessDashboardPaymentTransactionsTriggerNewSearch,
		setBusinessDashboardPaymentTransactionsInitialLoadDone,
		setBusinessDashboardPaymentTransactionsFilterPageNumber,
		fetchBusinessDashboardPaymentTransactions,
		setBusinessDashboardLeadsLoading,
		setBusinessDashboardListingsTriggerNewSearch,
		setBusinessDashboardListingsInitialLoadDone,
		setBusinessDashboardListingsLoading,
		setBusinessDashboardListingsFilterStatus,
		setBusinessDashboardListingsFilterListingType,
		setBusinessDashboardListingsFilterPropertyId,
		setBusinessDashboardListingsFilterTransactionType,
		setBusinessDashboardListingsFilterSortField,
		setBusinessDashboardListingsFilterSortOrder,
		setBusinessDashboardListingsFilterPageNumber,
		fetchBusinessDashboardListings,
		setBusinessDashboardAnalyticsLoading,
		setBusinessDashboardAnalyticsGraphSource,
		setBusinessDashboardAnalyticsFilterListingType,
		setBusinessDashboardAnalyticsFilterListingId,
		setBusinessDashboardAnalyticsFilterGraphTypeY,
		setBusinessDashboardAnalyticsFilterGraphDurationX,
		setBusinessDashboardAnalyticsFilterStartDateX,
		setBusinessDashboardAnalyticsFilterEndDateX,
		setBusinessDashboardUserViewTabValue,
		fetchBusinessProfileUserViewListings,
		businessDashboardAddAdminUserDetails,
		fetchBusinessDashboardAdmins,
		businessDashboardDeleteAdminUserDetails,
		setBusinessDashboardAdminLoading,
		fetchBusinessDashboardLeadsOverview,
		fetchBusinessDashboardPropertiesOverview,
		fetchBusinessDashboardOFBsOverview,
		fetchBusinessDashboardServicesOverview,
		fetchBusinessDashboardBoostsMobile,
		setBusinessDashboardBoostsFilterListingType,
		setBusinessDashboardBoostsFilterPageNumber,
		setBusinessDashboardBoostsFilterSortField,
		setBusinessDashboardBoostsFilterSortOrder,
		setBusinessDashboardBoostsFilterStatus,
		setBusinessDashboardBoostsInitialLoadDone,
		setBusinessDashboardBoostsLoading,
		setBusinessDashboardBoostsTriggerNewSearch,
		UpdateBusinessProfileTitle,
		UpdateBusinessProfilePicture,
		UpdateBusinessProfileLanguages,
		UpdateBusinessProfileAboutDetails,
		UpdateBusinessProfileAreasOfOperation,
		UpdateBusinessProfileListingsCount,
		FetchBusinessDashboardAnalyticsLeadsThisWeek,
		FetchBusinessDashboardAnalyticsMostLeadsGeneratingListing,
		FetchBusinessDashboardAnalyticsListingViewsThisWeek,
		FetchBusinessDashboardAnalyticsMostSavedListing,
		FetchBusinessDashboardAnalyticsProfileViews,
		FetchBusinessDashboardAnalyticsMostViewedListing,
		FetchBusinessDashboardAnalyticsGraph,
		FetchBusinessDashboardAnalyticsGraphCustomDates,
		CreateNewShares,
		fetchSingleUserSavedItems,
		setUserSavedItemsTriggerNewSearch,
		setUserSavedItemsInitialLoadDone,
		setUserSavedItemsLoading,
		setUserSavedItemsFilterListingType,
		setUserSavedItemsFilterPageNumber,
		UpdateUserDetail,
		switchBusinessDashboardContantDetails,
		switchBusinessDashboardPromotionalEmails,
		setPreviousPropertyData,
		fetchBusinessDashboardRewardsHistory,
		setBusinessDashboardRewardsHistoryFilterPageNumber,
		setBusinessDashboardRewardsHistoryInitialLoadDone,
		setBusinessDashboardRewardsHistoryTriggerNewSearch,
		setBusinessDashboardRewardsHistoryLoading,
		setBusinessDashboardRewardsLoading,
		setBusinessDashboardRewardsTriggerNewSearch,
		setBusinessDashboardRewardsInitialLoadDone,
		fetchBusinessDashboardRewards,
		setBusinessDashboardReferralsLoading,
		setBusinessDashboardReferralsTriggerNewSearch,
		setBusinessDashboardReferralsInitialLoadDone,
		setBusinessDashboardReferralsFilterPageNumber,
		fetchBusinessDashboardReferrals,
		fetchBusinessDashboardKycInfo,
		setSinglePropertyDeveloperSlug,
		setPropertyIsImagesUploading,
		setLoginFlowGlobalStateModalOpen,
		setLoginFlowGlobalStateUserCountryCode,
		setLoginFlowGlobalStateUserPhone,
		setLoginFlowGlobalStateUserOTP,
		setLoginFlowGlobalStateUserIsSignUp,
		setLoginFlowGlobalStateUserIsSignIn,
		setLoginFlowGlobalStateUserIsSignedIn,
		setLoginFlowGlobalStateUserUserId,
		setLoginFlowGlobalStateUserHasReferralCode,
		setLoginFlowGlobalStateUserReferralCode,
		setUsersSettingsCurrentScreen,
		setLoginFlowGlobalStateStageTriggerSource,
		setLoginFlowGlobalStateActionCallbackUrl,
		setLoginFlowGlobalStateActionSignIn,
		setLoginFlowGlobalStateActionSignUp,
		setLoginFlowGlobalStateActionSignOut,
		setLoginFlowGlobalStateUiType,
		setChatScreen,
		setChatListTab,
		setChatListTriggerNewSearch,
		setChatListInitialLoadDone,
		setChatListFilterPageNumber,
		setBroadcastListTriggerNewSearch,
		setBroadcastListInitialLoadDone,
		setBroadcastListLoading,
		setBroadcastListFilterPageNumber,
		setChatMessagesTriggerNewSearch,
		setChatMessagesInitialLoadDone,
		setChatMessagesLoading,
		setChatMessagesFilterPageNumber,
		fetchSentBroadcasts,
		fetchReceivedBroadcasts,
		removeReceivedBroadcastFromList,
		acceptedBroadcast,
		setBroadcastForm,
		setOpenChatModal,
		setCurrentChat,
		setOpenPostModal,
		fetchUserChats,
		fetchFeatureDiscoveryTracker,
		updateFeatureDiscoveryTracker,
		fetchChatMessages,
		UpdateBusinessProfileSpecialization,
		setLoginFlowGlobalStateUiSnackbarOpen,
		setLoginFlowGlobalStateUiSnackbarMessage,
		setLoginFlowGlobalStateUiSnackbarType,
		setLoginFlowGlobalStateUserFirstName,
		setLoginFlowGlobalStateUserLastName,
		setLoginFlowGlobalStateUserDisplayName,
		setLoginFlowGlobalStateReferrerFirstName,
		setLoginFlowGlobalStateReferrerLastName,
		setLoginFlowGlobalStateReferrerDisplayName,
		setLoginFlowGlobalStateReferrerCountryCode,
		setLoginFlowGlobalStateReferrerPhone,
		deleteChat,
		deleteChatMessage,
		setBusinessDashboardBroadcastFilterSortField,
		setBusinessDashboardBroadcastFilterStatus,
		setBusinessDashboardBroadcastFilterSortOrder,
		setBusinessDashboardBroadcastTriggerNewSearch,
		setBusinessDashboardPropertyBroadcastTriggerNewSearch,
		setBusinessDashboardPropertyBroadcastInitialLoadDone,
		setBusinessDashboardPropertyBroadcastsFilterPageNumber,
		fetchUserProperties,
		// setBusinessDashboardAiBoostForm,
		fetchAiMetaBoostedListings,
		setAiMetaBoostedListingsTriggerNewSearch,
		setAiMetaBoostedListingsInitialLoadDone,
		fetchRecomendedPropertiesToBoost,
		setBusinessDashboardAiBoostFormCustomBudget,
		setBusinessDashboardAiBoostFormBudget,
		fetchAiBoostBannerCardDetails,
		setMetaAiBoostDetailsSelectedCampaign,
		fetchMetaAiBoostsQualifiedLeads,
		fetchMetaAiBoostsBudgetDetails,
		setAiBoostFormAdCreativeBrandLogo,
		fetchMetaAiBoostsCampaignStats,
		fetchMetaAiBoostAllAdIds,
		setMetaAiBoostAdPreviewsFilterPageNumberCount,
		setAiBoostFormPropertyDetails,
		fetchMetaAiBoostActivityLogdData,
		setMetaAiBoostActivityLogsLoading,
		genetateAIBoostActivityLogsSummary,
		setSearchLeadsResponseBoostIds,
		setSingleLeadData,
		handleLeadsDetailsStatus,
		setLeadDetailsReminder,
		handleDeleteLeadReminder,
		updateBusinessDashboardLeadsAssignedTo,
		fetchBusinessDashboardTeamMembers,
		fetchAiMetaActiveCampaigns,
		fetchHomeScreenBroadcastWidget,
		fetchTopAgentAreas,
		fetchPerformanceAnalyticsBusinessDashboardHomeWidget,
		removejunkLeadFromList,
		fetchHomePageStats,
		fetchAllCampaignMetrics,
		setMetricsLoading,
		setBudgetAndLeadsLoading,
		fetchHomePageBeegruTopPicksData,
		fetchBusinessDashboardListingsCount,
		fetchClientCrmIntegrationWebhook,
		CreateCrmIntegrationWebhook,
		UpdateCrmIntegrationWebhook,
		TestCrmIntegrationWebhook,
		setCRMPayloadType,
		setCRMLeadIDField,
		setCRMNameField,
		setCRMPhoneNumberField,
		setCRMProjectNameField,
		setCRMStatusField,
		setCRMNotesField,
		setCRMLeadSourceField,
		setCRMEnquiredAtField,
		setCRMAPIKeyField,
		setCRMApiMethod,
		setCRMWebhookURL,
		setCRMName,
		setCRMEmailField,
		setCRMChannelIDField,
		setCRMHeadersKey,
		setCRMHeadersValue,
		setCRMAddNewHeaderField,
		setCRMRemoveHeaderField,
		setCRMWebhookApiKey,
		fetchAiBoostBannerCardDetailsLoading,
		fetchAiBoostAllBoostListsLoading,
		setAiBoostDetailsToNull,
		fetchBusinessDashboardActivityLogsData,
		loadMoreBusinessDashboardActivityLogsData,
		setActivityLogsLoading,
		fetchBusinessDashboarMembersAndAdminsData,
		fetchBusinessProfileAdmins,
		setBusinessDashboardLeadsFilterAssignedStatus,
		fetchHomePageFeaturedPlotsData,
		fetchHomePageTopVillasData,
		setSearchSortBy,
		setNerSearchTerm,
		setNerLastSearchedTerm,
		addNewBusinessProfileAdmin,
		removeBusinessProfileAdmin,
		updateBusinessProfileAdminRole,
		setChannelId,
		fetchKeyHighlights,
		fetchLocalitiesFaq,
		fetchCoreDetailsAndImages,
		fetchCuratedPropertyIds,
		fetchMapDetailsAndVicinity,
		fetchPriceTrends,
		updateCurrency,
		fetchGoogleCampaignsLists,
		fetchGoogleAIBoostCampaignMetrics,
		fetchGoogleAIBoostsQualifiedLeads,
		setFilterSelectedPlatform,
		setFilterSelectedCampaignId,
		updateCookieConsent,
		SetTeamInvite,
		SetPlatformAccessLevel,
		createRequirement,
		fetchMyRequirements,
		fetchSingleRequirement,
		updateRequirementStatus,
		updateRequirement,
		closeRequirement,
		setMyRequirementsFilterStatus,
		setMyRequirementsFilterPageNumber,
		setMyRequirementsFilterSortField,
		setMyRequirementsFilterSortOrder,
		setMyRequirementsTriggerNewSearch,
		setMyRequirementsLoading,
		setMyRequirementsInitialLoadDone,
		setMyRequirementsSelectedRequirementLoading,
		SetSalesSupportInvestment,
		SetPropertyClosure,
		setOpenCreateRequirementModal,
		fetchRequirementsFeed,
		fetchRequirementsFeedCounts,
		respondToRequirement,
		saveRequirement,
		unsaveRequirement,
		trackContactAction,
		setRequirementsFeedFilterTransactionType,
		setRequirementsFeedFilterPropertyCategory,
		setRequirementsFeedFilterLocation,
		setRequirementsFeedFilterPageNumber,
		setRequirementsFeedLoading,
		setRequirementsFeedInitialLoadDone,
		setRequirementsFeedTriggerNewSearch,
		setPropertyTranslations,
		setBbmPushNotificationTemplate,
		setBbmScheduledPushNotificationLog,
		setNotificationQueue,
	},

	/*

    * Extra Reducers. These are reducers that are required by next-redux-wrapper and allow us to use redux on the server.

   * UPDATE: We have to use the builder callback notation instead of the object notation for extraReducers as the object notation is now deprecated and will be removed in RTK 2.0.

    */

	extraReducers: (builder) => {
		builder.addCase(HYDRATE, (state: any, action: any) => {
			return {
				...state,
				...action.payload.globalState,
				/* The chat is client-only state: no page fills it on the server, so a hydrate only ever
				   brought the empty initial chat and closed or reset an open conversation on every
				   navigation (chat audit I12, 17 Oct 2026). The client's own chat state is kept. */
				...(state?.chat_states ? { chat_states: state.chat_states } : {}),
			};
		});
	},
});

const makeStore = () =>
	configureStore({
		reducer: {
			[globalSlice.name]: globalSlice.reducer,
		},

		/*

    * Redux DevTools only outside production (chat audit A22, 16 Oct 2026): in production they let
    * anyone with the extension read the whole store, chat payloads included.

    */

		devTools: process.env.NODE_ENV !== "production",
	});

/*

& Next, we'll describe and export the types for the AppStore, AppState and AppThunk. This is a good practice.

*/

export type AppStore = ReturnType<typeof makeStore>;
export type AppState = ReturnType<AppStore["getState"]>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action>;

/*

~ What is a thunk?

* Arguably, a 'thunk' is the sound your head makes when you hear first hear about "redux-thunk". Jokes aside, it is a function that returns a function. In redux, when you dispatch an action, a thunk allows you to run your reducer logic asynchronously.

* The term 'thunk' originated as a whimsical irregular form of the verb think. It refers to the original use of thunks in ALGOL 60 compilers, which required special analysis (thought) to determine what type of routine to generate.

* When you synchronously dispatch an action that is actually going to run asynchronous code, you're expecting the action to give you data that doesn't yet exist (the reducer has to think about it first). So 'thunk' is just a geeky way of describing a function that returns a function that returns data that the reducer will have already 'thunk' about before it is called.

& Now that you know what a thunk is (I hope), let us export the thunks for our app. To keep this file clean, we're going to describe our thunks in a separate file, export them, import them and then export them yet another time.

^ All thunks for this app are described in the redux-magic/thunks.ts file.

* As a rule of thumb, we're going to describe one thunk for every reducer that we describe.

*/
export {
	AddExperienceForUserThunk,
	AddHonorsAndAwardsDetailsForUserThunk,
	AddLicenseAndCertificationDetailsForUserThunk,
	AddSepcialOfferDetailsForBusinessProfileThunk,
	AddUserCoursesThunk,
	AddUserLanguageThunk,
	AddingBeegruPointsForSharePropertyThunk,
	AddingBeegruPointsForShareServiceThunk,
	AllowcopyPropertyThunk,
	BusinessDashboardCancelSubscriptionThunk,
	BusinessDashboardCreateNewSubscriptionThunk,
	BusinessDashboardRenewSubscriptionThunk,
	CancelPropertyBoostStateThunk,
	CancelSubscriptionThunk,
	CreateCrmIntegrationWebhookThunk,
	CreateNewCommentsThunk,
	CreateNewCommentsUserPostThunk,
	CreateNewPostThunk,
	CreateNewPostUserThunk,
	CreateNewPropertyThunk,
	CreateNewReviewThunk,
	CreateNewServiceThunk,
	CreateNewServiceWithUploadToolThunk,
	CreateNewSharesThunk,
	CreateNewSubscriptionThunk,
	CreateNewViewThunk,
	CreatePropertyBoostStateThunk,
	CreateWebsiteReportThunk,
	CropPropertyImageThunk,
	CropServiceImageThunk,
	EmployeeRequestThunk,
	FaqAddDownvoteThunk,
	FaqAddUpvoteThunk,
	FaqRemoveDownvoteThunk,
	FaqRemoveUpvoteThunk,
	FetchBusinessDashboardAnalyticsGraphCustomDatesThunk,
	FetchBusinessDashboardAnalyticsGraphThunk,
	FetchBusinessDashboardAnalyticsLeadsThisWeekThunk,
	FetchBusinessDashboardAnalyticsListingViewsThisWeekThunk,
	FetchBusinessDashboardAnalyticsMostLeadsGeneratingListingThunk,
	FetchBusinessDashboardAnalyticsMostSavedListingThunk,
	FetchBusinessDashboardAnalyticsMostViewedListingThunk,
	FetchBusinessDashboardAnalyticsProfileViewsThunk,
	FetchMoreBusinessProfilesThunk,
	KycProfileTypesThunk,
	LoadingMoreBusinessProfileGivenReviewsThunk,
	LoadingMoreBusinessProfilePostsThunk,
	LoadingMoreBusinessProfileReviewsThunk,
	LoadingMoreUserGivenReviewsThunk,
	LoadingMoreUserProfilePostsThunk,
	LoadingMoreUserReviewsThunk,
	NewEmployeeRquestOnBoardingThunk,
	OnBoardingThunk,
	ProfileToUpgradeIdThunk,
	ProfileToUpgradeThunk,
	ProfileToUpgradeTypeThunk,
	PublicPrivatePropertyThunk,
	PublicPrivateServiceThunk,
	PublishPropertyThunk,
	PublishServiceThunk,
	RemoveBoomsThunk,
	RenewSubscriptionThunk,
	ReplyToCommentThunk,
	SetDefaultLocationBoostThunk,
	SetDefaultLocationThunk,
	SetDefaultLookingForThunk,
	SetPropertyBoostDataStateThunk,
	SetPropertyBoostDetailStateThunk,
	SetPropertyBoostLocationStateThunk,
	// PropertyBoost
	SetPropertyBoostMobileStepStateThunk,
	SetPropertyBoostModalStateThunk,
	SetPropertyBoostPointsStateThunk,
	SetPropertyBoostSnackStateThunk,
	SetPropertyBoostedByStateThunk,
	SetPropertyLoadingStateThunk,
	SetintroThunk,
	ShowContactDetailsPropertyThunk,
	ShowContactDetailsServiceThunk,
	StoreLeadsThunk,
	TestCrmIntegrationWebhookThunk,
	UpdateAboutDeveloperThunk,
	UpdateAboutLocationPropertyThunk,
	UpdateAboutPropertyThunk,
	UpdateAiOverviewThunk,
	UpdateAmenitiesThunk,
	UpdateBroadcastReadStatusThunk,
	UpdateBusinessAboutThunk,
	UpdateBusinessBrokerageThunk,
	UpdateBusinessExpertiseThunk,
	UpdateBusinessFAQsThunk,
	UpdateBusinessLanguagesThunk,
	UpdateBusinessLicencesThunk,
	UpdateBusinessProfileAboutDetailsThunk,
	UpdateBusinessProfileAreasOfOperationThunk,
	UpdateBusinessProfileLanguagesThunk,
	UpdateBusinessProfileLeadsNotesThunk,
	UpdateBusinessProfileLeadsStatusThunk,
	UpdateBusinessProfileListingsCountThunk,
	UpdateBusinessProfilePictureThunk,
	UpdateBusinessProfileSpecializationThunk,
	UpdateBusinessProfileTitleThunk,
	UpdateBusinessServicesThunk,
	UpdateConfigAndAreaThunk,
	UpdateLeadsThunk,
	UpdateOverviewThunk,
	UpdatePropertyDetailsThunk,
	UpdatePropertyImageThunk,
	UpdatePropertyRegulatoryInfoThunk,
	UpdatePropertyTitleThunk, UpdateReduxSessionUserFieldsThunk, UpdateServiceAreasOfOperationThunk,
	UpdateServiceDetailsThunk,
	UpdateServiceImageThunk,
	UpdateServiceOverViewThunk,
	UpdateServiceProviderInfoThunk,
	UpdateServiceSpecificationThunk,
	UpdateServiceTitleThunk,
	UpdateUserAboutDetailsThunk,
	UpdateUserDetailThunk,
	UpdateUserProfileLeadsNotesThunk,
	UpdateUserProfileLeadsStatusThunk,
	UpdateUserSkillsThunk,
	UpdateVicinityThunk,
	acceptEmployeeRequestThunk, acceptTeamInviteThunk, acceptedBroadcastThunk, declineTeamInviteThunk,
	addAdminUserDetailsThunk,
	addBusinessProfilePictureThunk,
	addCoverImageThunk,
	addNewBusinessProfileAdminThunk,
	addNewNoteToLeadActivityLogsThunk,
	addProfilePictureThunk,
	addPropertyImagesThunk,
	addSaveEntityBusinessProfileThunk,
	addSaveEntityUserProfileThunk,
	addServiceImagesThunk,
	bookmarkThunk,
	businessDashboardAddAdminUserDetailsThunk,
	businessDashboardDeleteAdminUserDetailsThunk,
	businessProfileListTabViewThunk,
	cancelBoostThunk,
	changeAutoplayVideosThunk,
	changeDataTuningThunk,
	changeDefaultVideoQualityThunk,
	changeMeThunk,
	changeRecievePromotionalEmailsThunk, closeRequirementThunk, commentSwrThunk,
	createNewBroadcastThunk,
	createNewBusinessProfileThunk,
	createNewOFBPropertyThunk,
	createNewOFBPropertyUserThunk,
	createNewPropertyWithUploadToolThunk, createRequirementThunk, deleteAdminUserDetailsThunk,
	deleteBusinessProfilePictureThunk,
	deleteChatThunk,
	deleteChatMessageThunk,
	deleteDesktopLeadsThunk,
	deleteEmployeeRequestThunk,
	deleteMobileLeadsThunk,
	deletePostUserThunk,
	deletePropertyDetailsThunk,
	deletePropertyImageThunk,
	deletePropertyOFBDetailsThunk,
	deletePropertyOFBUserThunk,
	deleteReviewThunk,
	deleteServiceDetailsThunk,
	deleteServiceImageThunk,
	deleteUserCoverImageThunk,
	deleteUserProfilePictureThunk, exitBusinessProfileAdminThunk, fetchAboutSinglePropertyThunk,
	cancelBusinessProfileInviteThunk,
	resendBusinessProfileInviteThunk,
	transferBusinessProfileOwnershipThunk,
	fetchAccountSettingsFilesCountThunk,
	fetchAccountSettingsPageThunk,
	fetchAccountSettingsProfileKycInfoThunk,
	fetchAccountSettingsRewardTransactionThunk,
	fetchAccountSettingsSubscriptionsPlansThunk,
	fetchAccountSettingsSubscriptionsThunk,
	fetchAccountSettingsUserBeegruPointstransactionsThunk,
	fetchAccountSettingsUserCashtransactionsThunk,
	fetchAccountSettingsUserDataThunk,
	fetchAiBoostAllBoostListsLoadingThunk,
	fetchAiBoostAllBoostListsThunk,
	fetchAiBoostBannerCardDetailsLoadingThunk,
	fetchAiBoostBannerCardDetailsThunk,
	fetchAiMetaActiveCampaignsThunk,
	fetchAiMetaBoostedListingsThunk,
	fetchAllCampaignMetricsThunk,
	fetchBoostBusinessProfilePageThunk,
	fetchBoostPostPageThunk,
	fetchBoostPropertyPageThunk,
	fetchBoostServicePageThunk,
	fetchBoostUserProfilePageThunk,
	fetchBusinessDashboarMembersAndAdminsDataThunk,
	fetchBusinessDashboardActivityLogsDataThunk,
	fetchBusinessDashboardBeegruPointTransactionsThunk,
	fetchBusinessDashboardBoostsMobileThunk,
	fetchBusinessDashboardCashTransactionsThunk, fetchBusinessDashboardKycInfoThunk,
	fetchBusinessDashboardLeadsDesktopThunk,
	fetchBusinessDashboardLeadsMobileThunk,
	fetchBusinessDashboardLeadsOverviewThunk,
	fetchBusinessDashboardListingsCountThunk,
	fetchBusinessDashboardListingsThunk,
	fetchBusinessDashboardNewListingsThunk,
	fetchBusinessDashboardOFBsOverviewThunk, fetchBusinessDashboardPaymentTransactionsThunk, fetchBusinessDashboardProfileDataThunk,
	fetchBusinessDashboardPropertiesOverviewThunk,
	fetchBusinessDashboardReferralsThunk,
	fetchBusinessDashboardReviewsMobileThunk,
	fetchBusinessDashboardRewardsHistoryThunk,
	fetchBusinessDashboardRewardsThunk,
	fetchBusinessDashboardSavedItemsThunk,
	fetchBusinessDashboardServicesOverviewThunk,
	fetchBusinessDashboardTeamMembersThunk,
	fetchBusinessProfileAboutDetailsThunk,
	fetchBusinessProfileAdminsDetailsAndEmployeeRequestThunk,
	fetchBusinessProfileAdminsThunk,
	fetchBusinessProfileAnalyticsOFBsThunk,
	fetchBusinessProfileAnalyticsPostThunk,
	fetchBusinessProfileAnalyticsPropertyThunk,
	fetchBusinessProfileAnalyticsServiceThunk,
	fetchBusinessProfileBrokerageThunk,
	fetchBusinessProfileExpertiseThunk,
	fetchBusinessProfileFaqsThunk,
	fetchBusinessProfileFollowerAndFollowingThunk,
	fetchBusinessProfileGivenReviewsThunk,
	fetchBusinessProfileImagesThunk,
	fetchBusinessProfileLanguagesThunk,
	fetchBusinessProfileLeadsThunk,
	fetchBusinessProfileLicencesAndCertificatesThunk,
	fetchBusinessProfileListingOFBThunk,
	fetchBusinessProfileListingPropertyThunk,
	fetchBusinessProfileListingServiceThunk,
	fetchBusinessProfileNoOfEmployeesThunk,
	fetchBusinessProfilePostsThunk,
	fetchBusinessProfilePublishedPropertiesThunk,
	fetchBusinessProfilePublishedServicesThunk,
	fetchBusinessProfileReviewsThunk,
	fetchBusinessProfileSavedOFBThunk,
	fetchBusinessProfileSavedPostThunk,
	fetchBusinessProfileSavedPropertyThunk,
	fetchBusinessProfileSavedServiceThunk,
	fetchBusinessProfileServiceOfferedThunk,
	fetchBusinessProfileSubscriptionThunk,
	fetchBusinessProfileUserViewListingsThunk,
	fetchCategoryFaqsThunk,
	fetchChatMessagesThunk,
	fetchCoreDetailsAndImagesThunk,
	fetchCuratedPropertyIdsThunk,
	fetchDevelopersThunk,
	fetchFaqsThunk,
	fetchFeatureDiscoveryTrackerThunk,
	fetchGlobalSearchResultsThunk,
	fetchGoogleAIBoostCampaignMetricsThunk,
	fetchGoogleAIBoostsQualifiedLeadsThunk,
	fetchGoogleCampaignsListsThunk,
	fetchHomePageBeegruTopPicksThunk,
	fetchHomePageFeaturedPlotsThunk,
	fetchHomePageFeaturedPropertiesThunk,
	fetchHomePageHotPropertiesBuyLocalStorageThunk,
	fetchHomePageHotPropertiesOfbLocalStorageThunk,
	fetchHomePageHotPropertiesRentLocalStorageThunk,
	fetchHomePageHotPropertiesThunk,
	fetchHomePageThunk,
	// fetchHomePageTrendingUsersThunk,
	fetchHomePageTopBusinessProfilesThunk,
	fetchHomePageTopDevelopersThunk,
	fetchHomePageTopServicesThunk,
	// fetchHomePageTrendingServicesThunk,
	fetchHomePageTopUsersThunk,
	fetchHomeScreenBroadcastWidgetThunk,
	fetchHomeTopVillasPageThunk,
	fetchHomepageDashboardStatsThunk,
	fetchKeyHighlightsThunk,
	fetchLeadsByIdThunk,
	fetchLocalitiesFaqThunk,
	fetchMapDetailsAndVicinityThunk,
	fetchMetaAiBoostActivityLogdDataThunk,
	fetchMetaAiBoostAllAdIdsThunk,
	fetchMetaAiBoostsAdCreativesThunk,
	fetchMetaAiBoostsBudgetDetailsThunk,
	fetchMetaAiBoostsCampaignStatsThunk,
	fetchMetaAiBoostsQualifiedLeadsThunk, fetchMyRequirementsThunk, fetchUserRequirementsThunk, fetchNearbyPropertiesThunk,
	fetchNeighbourhoodReviewsPageThunk,
	fetchNotificationPageThunk,
	fetchOnBoardingBusinessTitleThunk,
	fetchOneTimeRewardsThunk,
	fetchPerformanceAnalyticsBusinessDashboardHomeWidgetThunk,
	fetchPriceTrendsThunk,
	fetchPropertyCardThunk,
	fetchPropertyDataReviewsPageThunk,
	fetchPropertyReviewsPageThunk,
	fetchPropertyUserDataReviewsPageThunk,
	fetchRealtimeNewChatMessageThunk,
	fetchRealtimeNotificationThunk,
	fetchReceiptPageThunk,
	fetchReceivedBroadcastsThunk,
	fetchRecomendedPropertiesToBoostThunk,
	fetchRecurringRewardsThunk, fetchRequirementsFeedCountsThunk, fetchRequirementsFeedThunk, fetchSearchThunk,
	fetchSentBroadcastsThunk,
	fetchServiceDataReviewsPageThunk,
	fetchServiceReviewsPageThunk,
	fetchServiceUserDataReviewsPageThunk,
	fetchSingleBusinessProfileThunk,
	fetchSingleFaqThunk,
	fetchSinglePostThunk,
	fetchSinglePropertyAboutLocationThunk,
	fetchSinglePropertyAmenitiesThunk,
	fetchSinglePropertyConfigAndAreaThunk,
	fetchSinglePropertyCreatorThunk,
	fetchSinglePropertyDetailsThunk,
	fetchSinglePropertyDeveloperThunk,
	fetchSinglePropertyHotPropertiesThunk,
	fetchSinglePropertyImagesThunk,
	fetchSinglePropertyLocationCoordinatesThunk,
	fetchSinglePropertyNeighbourhoodReviewsThunk,
	fetchSinglePropertyOverviewThunk,
	fetchSinglePropertyReviewsThunk,
	fetchSinglePropertyThunk,
	fetchSinglePropertyTrendingPropertiesThunk,
	fetchSinglePropertyVicinityThunk, fetchSingleRequirementThunk, fetchSingleServiceAreasOfOperationThunk,
	fetchSingleServiceCreatorDetailsThunk,
	fetchSingleServiceDetailsThunk,
	fetchSingleServiceImagesThunk,
	fetchSingleServiceMapViewThunk,
	fetchSingleServiceOverviewThunk,
	fetchSingleServicePageThunk,
	fetchSingleServiceProviderThunk,
	fetchSingleServiceReviewsThunk,
	fetchSingleServiceSpecificationsThunk,
	fetchSingleServiceTopServicesThunk,
	fetchSingleServiceTrendingServicesThunk,
	fetchSingleUserAnalyticsThunk,
	fetchSingleUserProfileAboutDetailsThunk,
	// fetchHomePageTrendingBusinessProfilesThunk,
	fetchSingleUserProfileCoverImageAndProfilePictureThunk,
	fetchSingleUserProfileFollowersAndFollowingsThunk,
	fetchSingleUserProfileGivenReviewsThunk,
	fetchSingleUserProfileListingsThunk,
	fetchSingleUserProfilePostsThunk,
	fetchSingleUserProfileReviewsThunk,
	fetchSingleUserProfileThunk,
	fetchSingleUserSavedItemsThunk,
	fetchSingleUserSavedOFBThunk,
	fetchSingleUserSavedPostThunk,
	fetchSingleUserSavedPropertiesThunk,
	fetchSingleUserSavedServiceThunk, fetchTeamInviteThunk, fetchTeamInviteDetailsThunk, fetchTransferCandidatesThunk, fetchTopAgentAreasThunk,
	fetchUserChatsThunk,
	fetchUserProfileLeadsThunk,
	followUserThunk,
	genetateAIBoostActivityLogsSummaryThunk,
	handleDeleteLeadReminderThunk,
	handleLeadsDetailsStatusThunk,
	loadMoreBusinessDashboardActivityLogsDataThunk,
	loadMoreGlobalSearchPostsThunk,
	loadMoreGlobalSearchResultsThunk,
	loadMoreNotificationPageThunk,
	loadMoreOfbPropertyThunk,
	loadMorePropertiesThunk,
	loadMoreSavedOFBThunk,
	loadMoreSavedPostsThunk,
	loadMoreSavedPropertiesThunk,
	loadMoreSavedServicesThunk,
	loadMoreServicesThunk,
	loadMoreUserPropertiesThunk,
	loadMoreUserSavedOFBThunk,
	loadMoreUserSavedPostsThunk,
	loadMoreUserSavedPropertiesThunk,
	loadMoreUserSavedServicesThunk,
	postSwrForBusinessThunk,
	postSwrForUserThunk,
	profileContextThunk,
	removeBusinessProfileAdminThunk, removeReceivedBroadcastFromListThunk,
	removejunkLeadFromListThunk,
	reportPostThunk, respondToRequirementThunk,
	saveRequirementThunk, searchBusinessProfileOfbPropertiesThunk,
	searchBusinessProfilePropertiesThunk,
	searchBusinessProfileServicesThunk,
	searchOfbPropertyListingsThunk,
	searchPropertyListingsThunk,
	searchServiceListingsThunk,
	searchUserPropertiesThunk,
	searchUserPropertyListingsThunk,
	sendChatMessageThunk,
	acceptChatRequestThunk,
	declineChatRequestThunk,
	setCurrentChatSettingsThunk,
	muteChatThunk,
	reactToChatMessageThunk,
	refreshMessageReactionsThunk,
	refreshChatReceiptsThunk,
	refreshChatMessageThunk,
	setChatEditingThunk,
	setChatListAllCountThunk,
	setChatTypingThunk,
	editChatMessageThunk,
	refreshChatListUnreadThunk,
	setChatReplyToThunk,
	setAccountSettingsSnackbarThunk,
	setActionForboomsThunk,
	setActivityLogsLoadingThunk,
	setAiBoostDetailsToNullThunk,
	setAiBoostFormAdCreativeBrandLogoThunk,
	setAiBoostFormAdCreativeImageThunk,
	setAiBoostFormAdCreativeReferenceImagesThunk,
	setAiBoostFormOfflinePaymentThunk,
	setAiBoostFormPropertyDetailsThunk,
	setAiMetaBoostedListingsFilterStatusThunk,
	setAiMetaBoostedListingsInitialLoadDoneThunk,
	setAiMetaBoostedListingsTriggerNewSearchThunk,
	setAnalyticsTabValueThunk,
	setBottomBuyBeegruPointsThunk,
	setBroadcastFormThunk,
	setBroadcastListFilterPageNumberThunk,
	setBroadcastListInitialLoadDoneThunk,
	setBroadcastListLoadingThunk,
	setBroadcastListTriggerNewSearchThunk,
	setBusinessDashboardAdminLoadingThunk,
	setBusinessDashboardAiBoostFormBudgetThunk,
	setBusinessDashboardAiBoostFormCustomBudgetThunk,
	// setBusinessDashboardAiBoostFormThunk,
	setBusinessDashboardAnalyticsFilterEndDateXThunk,
	setBusinessDashboardAnalyticsFilterGraphDurationXThunk,
	setBusinessDashboardAnalyticsFilterGraphTypeYThunk,
	setBusinessDashboardAnalyticsFilterListingIdThunk,
	setBusinessDashboardAnalyticsFilterListingTypeThunk,
	setBusinessDashboardAnalyticsFilterStartDateXThunk,
	setBusinessDashboardAnalyticsGraphSourceThunk,
	setBusinessDashboardAnalyticsLoadingThunk,
	setBusinessDashboardBeegruPointTransactionsFilterPageNumberThunk,
	setBusinessDashboardBeegruPointTransactionsInitialLoadDoneThunk,
	setBusinessDashboardBeegruPointTransactionsLoadingThunk,
	setBusinessDashboardBeegruPointTransactionsTriggerNewSearchThunk,
	setBusinessDashboardBoostsFilterListingTypeThunk,
	setBusinessDashboardBoostsFilterPageNumberThunk,
	setBusinessDashboardBoostsFilterSortFieldThunk,
	setBusinessDashboardBoostsFilterSortOrderThunk,
	setBusinessDashboardBoostsFilterStatusThunk,
	setBusinessDashboardBoostsInitialLoadDoneThunk,
	setBusinessDashboardBoostsLoadingThunk,
	setBusinessDashboardBoostsTriggerNewSearchThunk,
	setBusinessDashboardBroadcastFilterSortFieldThunk,
	setBusinessDashboardBroadcastFilterStatusThunk,
	setBusinessDashboardBroadcastFilterSortOrderThunk,
	setBusinessDashboardBroadcastTriggerNewSearchThunk,
	setBusinessDashboardCashTransactionsFilterPageNumberThunk,
	setBusinessDashboardCashTransactionsInitialLoadDoneThunk,
	setBusinessDashboardCashTransactionsLoadingThunk,
	setBusinessDashboardCashTransactionsTriggerNewSearchThunk, setBusinessDashboardCurrentScreenThunk,
	setBusinessDashboardLeadsFilterAssignedStatusThunk,
	setBusinessDashboardLeadsFilterListingTypeThunk,
	setBusinessDashboardLeadsFilterPageNumberThunk,
	setBusinessDashboardLeadsFilterPropertyThunk,
	setBusinessDashboardLeadsFilterDateRangeThunk,
	setBusinessDashboardLeadsFilterAssignedToUserIdsThunk,
	setBusinessDashboardLeadsFilterSortFieldThunk,
	setBusinessDashboardLeadsFilterSortOrderThunk,
	setBusinessDashboardLeadsFilterStatusThunk,
	setBusinessDashboardLeadsInitialLoadDoneThunk,
	setBusinessDashboardLeadsLoadingThunk,
	setBusinessDashboardLeadsTriggerNewSearchThunk,
	setBusinessDashboardListingsFilterListingTypeThunk,
	setBusinessDashboardListingsFilterPageNumberThunk,
	setBusinessDashboardListingsFilterPropertyIdThunk,
	setBusinessDashboardListingsFilterSortFieldThunk,
	setBusinessDashboardListingsFilterSortOrderThunk,
	setBusinessDashboardListingsFilterStatusThunk,
	setBusinessDashboardListingsFilterTransactionTypeThunk,
	setBusinessDashboardListingsInitialLoadDoneThunk,
	setBusinessDashboardListingsLoadingThunk,
	setBusinessDashboardListingsTriggerNewSearchThunk, setBusinessDashboardPaymentTransactionsFilterPageNumberThunk,
	setBusinessDashboardPaymentTransactionsInitialLoadDoneThunk,
	setBusinessDashboardPaymentTransactionsLoadingThunk,
	setBusinessDashboardPaymentTransactionsTriggerNewSearchThunk, setBusinessDashboardPromotionalEmailsLoadingThunk,
	setBusinessDashboardPropertyBroadcastInitialLoadDoneThunk,
	setBusinessDashboardPropertyBroadcastTriggerNewSearchThunk,
	setBusinessDashboardPropertyBroadcastsFilterPageNumberThunk,
	setBusinessDashboardReferralsFilterPageNumberThunk,
	setBusinessDashboardReferralsInitialLoadDoneThunk,
	setBusinessDashboardReferralsLoadingThunk,
	setBusinessDashboardReferralsTriggerNewSearchThunk,
	setBusinessDashboardReviewsFilterPageNumberThunk,
	setBusinessDashboardReviewsFilterSortFieldThunk,
	setBusinessDashboardReviewsFilterSortOrderThunk,
	setBusinessDashboardReviewsInitialLoadDoneThunk,
	setBusinessDashboardReviewsTriggerNewSearchThunk,
	setBusinessDashboardRewardsHistoryFilterPageNumberThunk,
	setBusinessDashboardRewardsHistoryInitialLoadDoneThunk,
	setBusinessDashboardRewardsHistoryLoadingThunk,
	setBusinessDashboardRewardsHistoryTriggerNewSearchThunk,
	setBusinessDashboardRewardsInitialLoadDoneThunk,
	setBusinessDashboardRewardsLoadingThunk,
	setBusinessDashboardRewardsTriggerNewSearchThunk,
	setBusinessDashboardSavedItemsFilterListingTypeThunk,
	setBusinessDashboardSavedItemsFilterPageNumberThunk,
	setBusinessDashboardSavedItemsInitialLoadDoneThunk,
	setBusinessDashboardSavedItemsLoadingThunk,
	setBusinessDashboardSavedItemsTriggerNewSearchThunk,
	setBusinessDashboardShowContactDetailsLoadingThunk,
	setBusinessDashboardUserViewTabValueThunk,
	setBusinessProfileAboutOfficeAddressThunk,
	setBusinessProfileAboutShortDescriptionThunk,
	setBusinessProfileAboutWebsiteUrlThunk,
	setBusinessProfileAboutYearEstablishedThunk,
	setBusinessProfileBrokerageThunk,
	setBusinessProfileEmailThunk,
	setBusinessProfileExpertiseThunk,
	setBusinessProfileFAQThunk,
	setBusinessProfileLanguagesThunk,
	setBusinessProfileLicencesAndCertificatesThunk,
	setBusinessProfileNoOfEmployeesThunk,
	setBusinessProfilePhoneCountryCodeThunk,
	setBusinessProfilePhoneNumberThunk,
	setBusinessProfileServicesOfferedTagsThunk,
	setBusinessProfileSnackbarThunk,
	setCRMAPIKeyFieldThunk,
	setCRMAddNewHeaderFieldThunk,
	setCRMApiMethodThunk,
	setCRMChannelIDFieldThunk,
	setCRMEmailFieldThunk,
	setCRMEnquiredAtFieldThunk,
	setCRMHeadersKeyThunk,
	setCRMHeadersValueThunk,
	setCRMLeadIDFieldThunk,
	setCRMLeadSourceFieldThunk,
	setCRMNameFieldThunk,
	setCRMNameThunk,
	setCRMNotesFieldThunk,
	setCRMPayloadTypeThunk,
	setCRMPhoneNumberFieldThunk,
	setCRMProjectNameFieldThunk,
	setCRMRemoveHeaderFieldThunk,
	setCRMStatusFieldThunk,
	setCRMWebhookApiKeyThunk,
	setCRMWebhookURLThunk,
	setChannelIdThunk,
	setChatListFilterPageNumberThunk,
	setChatListInitialLoadDoneThunk,
	setChatListTabThunk,
	setChatListTriggerNewSearchThunk,
	setChatMessagesFilterPageNumberThunk,
	setChatMessagesInitialLoadDoneThunk,
	setChatMessagesLoadingThunk,
	setChatMessagesTriggerNewSearchThunk,
	setChatScreenThunk,
	setCreateBoostThunk,
	setCreateNePropertyMinBalconiesThunk,
	setCreateNewPropertyAgeThunk,
	setCreateNewPropertyAvailabiltyThunk, setCreateNewPropertyBrokerLicensePermitNameThunk, setCreateNewPropertyBrokerLicensePermitNumberThunk, setCreateNewPropertyCategoryTypeThunk,
	setCreateNewPropertyCurrencyThunk,
	setCreateNewPropertyCurrentPageThunk,
	setCreateNewPropertyDefaultLocationThunk,
	setCreateNewPropertyFloorNoThunk,
	setCreateNewPropertyFurnishingThunk, setCreateNewPropertyIssuingAuthorityThunk, setCreateNewPropertyLandAreaThunk,
	setCreateNewPropertyLandAreaUnitThunk,
	setCreateNewPropertyLandFacingThunk,
	setCreateNewPropertyMaxBalconiesThunk,
	setCreateNewPropertyMaxBathroomsThunk,
	setCreateNewPropertyMaxBedroomsThunk,
	setCreateNewPropertyMaxCarpetAreaThunk,
	setCreateNewPropertyMaxFloorsThunk,
	setCreateNewPropertyMaxPriceThunk,
	setCreateNewPropertyMaxSuperBuiltUpAreaThunk,
	setCreateNewPropertyMinBathroomsThunk,
	setCreateNewPropertyMinBedroomsThunk,
	setCreateNewPropertyMinCarpetAreaThunk,
	setCreateNewPropertyMinPriceThunk,
	setCreateNewPropertyMinSuperBuiltUpAreaThunk,
	setCreateNewPropertyNoOfSeatsThunk,
	setCreateNewPropertyNoOfUnitsThunk,
	setCreateNewPropertyOverviewThunk,
	setCreateNewPropertyPermitNumberThunk, setCreateNewPropertyPlotDimensionsThunk,
	setCreateNewPropertySecurityDepositThunk,
	setCreateNewPropertySubTypeThunk,
	setCreateNewPropertySuperBuiltUpAreaUnitThunk,
	setCreateNewPropertyTransactionTypeThunk,
	setCreateNewPropertyTypeThunk,
	setCreateNewPropertyUnitFacingThunk,
	setCreateNewPropertyUploadImagesThunk,
	setCreateNewServiceCategoryThunk,
	setCreateNewServiceCurrentPageThunk,
	setCreateNewServiceDefaultLocationThunk,
	setCreateNewServiceMaxPriceThunk,
	setCreateNewServiceMinPriceThunk,
	setCreateNewServiceOtherSubTypeThunk,
	setCreateNewServiceProviderNameThunk,
	setCreateNewServiceShowPriceThunk,
	setCreateNewServiceSubTypeThunk,
	setCreateNewServiceTypeThunk,
	setCreateNewServiceUploadImagesThunk,
	setCreateNewePropertyPossessionDateThunk,
	setCreatePropertySelectedImagesUrlThunk,
	setCurrentChatThunk,
	setDataBeforeEditThunk,
	setDefaultProfileContextThunk,
	setFaqSearchResultsThunk,
	setFilterSelectedCampaignIdThunk,
	setFilterSelectedPlatformThunk,
	setHomeLoadingThunk,
	setHomeLocationThunk,
	setHomePageBusinessProfileLoadingThunk,
	setHomePagePropertiesLoadingThunk,
	setImageCategoryThunk,
	setImagesIndexThunk,
	setIsLoadingThunk,
	setIsSearchingThunk,
	setLanguageThunk,
	setLeadDetailsReminderThunk,
	setListingTabValueThunk,
	setLoadingThunk,
	setLoginFlowGlobalStateActionCallbackUrlThunk,
	setLoginFlowGlobalStateActionSignInThunk,
	setLoginFlowGlobalStateActionSignOutThunk,
	setLoginFlowGlobalStateActionSignUpThunk,
	setLoginFlowGlobalStateModalOpenThunk,
	setLoginFlowGlobalStateReferrerCountryCodeThunk,
	setLoginFlowGlobalStateReferrerDisplayNameThunk,
	setLoginFlowGlobalStateReferrerFirstNameThunk,
	setLoginFlowGlobalStateReferrerLastNameThunk,
	setLoginFlowGlobalStateReferrerPhoneThunk,
	setLoginFlowGlobalStateStageTriggerSourceThunk,
	setLoginFlowGlobalStateUiSnackbarMessageThunk,
	setLoginFlowGlobalStateUiSnackbarOpenThunk,
	setLoginFlowGlobalStateUiSnackbarTypeThunk,
	setLoginFlowGlobalStateUiTypeThunk,
	setLoginFlowGlobalStateUserCountryCodeThunk,
	setLoginFlowGlobalStateUserDisplayNameThunk,
	setLoginFlowGlobalStateUserFirstNameThunk,
	setLoginFlowGlobalStateUserHasReferralCodeThunk,
	setLoginFlowGlobalStateUserIsSignInThunk,
	setLoginFlowGlobalStateUserIsSignUpThunk,
	setLoginFlowGlobalStateUserIsSignedInThunk,
	setLoginFlowGlobalStateUserLastNameThunk,
	setLoginFlowGlobalStateUserOTPThunk,
	setLoginFlowGlobalStateUserPhoneThunk,
	setLoginFlowGlobalStateUserReferralCodeThunk,
	setLoginFlowGlobalStateUserUserIdThunk,
	setMetaAiBoostActivityLogsLoadingThunk,
	setMetaAiBoostAdPreviewsFilterPageNumberCountThunk,
	setMetaAiBoostDetailsSelectedCampaignThunk,
	setMetaCreativesLoadingThunk,
	setMetricsLoadingThunk, setMyRequirementsFilterPageNumberThunk,
	setMyRequirementsFilterSortFieldThunk,
	setMyRequirementsFilterSortOrderThunk, setMyRequirementsFilterStatusThunk, requirementActionThunk, fetchRequirementsFeedV2Thunk, setMyRequirementsInitialLoadDoneThunk, setMyRequirementsLoadingThunk, setMyRequirementsSelectedRequirementLoadingThunk, setMyRequirementsTriggerNewSearchThunk, setNerLastSearchedTermThunk,
	setNerSearchTermThunk,
	setOnBoardingDetailsThunk,
	setOpenChatModalThunk, setOpenCreateRequirementModalThunk, setOpenPostModalThunk,
	setPostPropertyWithUploadToolSnackbarErrorThunk,
	setPreviousPropertyDataThunk,
	setPreviousServiceDataThunk,
	setProfileContextThunk,
	setPropertyIdForCampaignDetailsThunk,
	setPropertyImagesUploadCompletedThunk,
	setPropertyIsImagesUploadingThunk,
	setPropertySnackbarThunk,
	setRecommendedPropertiesInitialLoadDoneThunk,
	setRecommendedPropertiesTriggerNewSearchThunk, setRequirementsFeedFilterLocationThunk,
	setRequirementsFeedFilterPageNumberThunk, setRequirementsFeedFilterPropertyCategoryThunk, setRequirementsFeedFilterTransactionTypeThunk, setRequirementsFeedInitialLoadDoneThunk, setRequirementsFeedLoadingThunk, setRequirementsFeedTriggerNewSearchThunk, setSaveTabValueThunk,
	setSavedIsPublicThunk,
	setSearchAnimationDetailsThunk,
	setSearchFilterMetricesThunk,
	setSearchLeadsResponseBoostIdsThunk,
	setSearchOFBThunk,
	setSearchPropertiesThunk,
	setSearchResultsPageNumberThunk,
	setSearchServiceThunk,
	setSearchSortByThunk,
	setSectionToEditThunk,
	setServiceImagesUploadCompletedThunk,
	setServiceIsImagesUploadingThunk,
	setServiceSnackbarThunk,
	setSingleLeadDataThunk,
	setSinglePropertyAboutLocationThunk,
	setSinglePropertyAboutThunk,
	setSinglePropertyAgeThunk,
	setSinglePropertyAmenitiesThunk,
	setSinglePropertyAvailabiltyThunk,
	setSinglePropertyCategoryTypeThunk,
	setSinglePropertyCurrencyThunk,
	setSinglePropertyDescriptionThunk,
	setSinglePropertyDeveloperNameThunk,
	setSinglePropertyDeveloperSlugThunk,
	setSinglePropertyEstablishedYearThunk,
	setSinglePropertyFloorNoThunk,
	setSinglePropertyFurnishingThunk,
	setSinglePropertyLandAreaThunk,
	setSinglePropertyLandFacingThunk,
	setSinglePropertyManualOverviewThunk,
	setSinglePropertyMaxBalconiesThunk,
	setSinglePropertyMaxBathroomsThunk,
	setSinglePropertyMaxBedroomsThunk,
	setSinglePropertyMaxCarpetAreaThunk,
	setSinglePropertyMaxFloorsThunk,
	setSinglePropertyMaxPriceThunk,
	setSinglePropertyMaxSuperBuiltUpAreaThunk,
	setSinglePropertyMinBalconiesThunk,
	setSinglePropertyMinBathroomsThunk,
	setSinglePropertyMinBedroomsThunk,
	setSinglePropertyMinCarpetAreaThunk,
	setSinglePropertyMinPriceThunk,
	setSinglePropertyMinSuperBuiltUpAreaThunk,
	setSinglePropertyNoOfSeatsThunk,
	setSinglePropertyNoOfUnitsThunk,
	setSinglePropertyOtherPlotDimensionsThunk,
	setSinglePropertyOverviewThunk,
	setSinglePropertyPlotDimensionsThunk,
	setSinglePropertyPossessionDateThunk,
	setSinglePropertySecurityDepositThunk,
	setSinglePropertySubTypeThunk,
	setSinglePropertyTagsThunk,
	setSinglePropertyTransactionTypeThunk,
	setSinglePropertyTypeThunk,
	setSinglePropertyUnitFacingThunk,
	setSinglePropertyVicinityThunk,
	setSingleServiceAreasOfOperationThunk,
	setSingleServiceCategoryThunk,
	setSingleServiceLocationCoordinatesThunk,
	setSingleServiceLocationPincodeThunk,
	setSingleServiceLocationTitleThunk,
	setSingleServiceMaxPriceThunk,
	setSingleServiceMinPriceThunk,
	setSingleServiceOtherSubtypeThunk,
	setSingleServiceOverviewThunk,
	setSingleServiceProviderDescriptionThunk,
	setSingleServiceProviderEstablishedYearThunk,
	setSingleServiceProviderNameThunk,
	setSingleServiceShowPriceThunk,
	setSingleServiceSpecificationThunk,
	setSingleServiceSubtypeThunk,
	setSingleServiceTagsThunk,
	setSingleServiceTypeThunk,
	setStartBoostThunk,
	setTabValueThunk,
	setThemeThunk,
	setTransactionTypeThunk,
	setUserLoadingThunk,
	setUserLocationThunk,
	setUserSavedItemsFilterListingTypeThunk,
	setUserSavedItemsFilterPageNumberThunk,
	setUserSavedItemsInitialLoadDoneThunk,
	setUserSavedItemsLoadingThunk,
	setUserSavedItemsTriggerNewSearchThunk,
	setUsersSettingsCurrentScreenThunk,
	switchBusinessDashboardContantDetailsThunk,
	switchBusinessDashboardPromotionalEmailsThunk, trackContactActionThunk, unfollowUserThunk, unsaveRequirementThunk, updateBeegrupointsAfterPurchaseThunk,
	updateBlastsThunk,
	updateBoomsThunk,
	updateBoostThunk,
	updateBusinessDashboardLeadsAssignedToThunk,
	updateBusinessProfileAdminRoleThunk,
	updateBusinessProfileKycInfoThunk,
	updateCookieConsentThunk,
	updateCurrencyThunk,
	updateFeatureDiscoveryTrackerThunk,
	updateLocationPropertyThunk,
	updateNoOfEmployeesThunk,
	updateNotificationViewedThunk,
	updateNotificationsViewedThunk,
	updatePersonalInfoThunk,
	updateReduxSessionThunk, updateRequirementStatusThunk,
	updateRequirementThunk, updateSearchFilterActiveOptionsThunk,
	updateSearchFilterSelectedOptionsThunk,
	updateServiceLocationThunk,
	updateUserKycInfoThunk,
	updatedPublishedPropertiesThunk,
	updatedPublishedServicesThunk,
	FetchSalesSupportInvestmentThunk,
	FetchPropertyClosureThunk
} from "./thunks";
/*

& Now, we'll export the default wrapper function. This is the function that will be used to wrap our NextJS app with redux.

* This wrapper is used in pages/_app.tsx to wrap the app and when using getStaticProps() or getServerSideProps() in individual page files in pages/<filename>.tsx.

*/

export const wrapper = createWrapper<AppStore>(makeStore, {
	/*

    TODO Remove all debug flags before going live.

    */

	debug: false,

	/*

    * These are custom serialization and deserialization functions that are used to serialize and deserialize the state. While what we're doing here is not necessary, we'll leave these here in case we decide to turn redux-magic into redux-black-magic in the future. He-who-must-not-be-named will certainly be pleased.

    */

	serializeState: (state: AppState) => JSON.stringify(state),
	deserializeState: (state: string) => JSON.parse(state),
});

/*

& Finally, we're going to export a function that will allow us to choose a slice. Since we are using one global slice, all the extra bits that allow the choosing to take place are not necessary and have been omitted from this description as such.

*/

export const sliceSelector = () => (state: AppState) => state?.[globalSlice.name];
